var _defs, _path, _rect, _rect2, _rect3, _rect4, _polygon, _rect5, _rect6, _rect7, _rect8, _polygon2, _rect9, _rect10, _rect11, _path2, _rect12, _rect13, _path3, _path4, _rect14, _path5, _rect15, _path6, _polygon3, _polygon4, _polygon5, _polygon6, _path7, _path8, _path9, _rect16, _polygon7, _path10, _rect17, _rect18, _path11, _rect19, _rect20, _path12, _polygon8, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _rect21, _rect22, _path21, _path22, _rect23, _rect24, _rect25, _path23, _path24, _rect26, _path25, _path26, _path27, _path28, _polygon9, _path29, _path30, _rect27, _path31, _path32, _path33, _path34, _path35, _rect28, _path36, _path37, _path38, _rect29, _path39, _rect30, _circle, _rect31, _path40, _path41, _path42, _path43, _rect32, _path44, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _path45, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _circle2, _path46, _rect60, _rect61, _path47, _path48, _path49, _path50, _path51, _path52, _rect62, _rect63, _path53, _rect64, _rect65, _rect66, _path54, _rect67, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _rect68, _path63, _rect69, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _rect70, _polygon10, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _circle3, _path83, _path84, _path85, _path86, _rect71, _rect72, _path87, _path88, _rect73, _rect74, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _rect75, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _rect76, _rect77, _rect78, _rect79, _polygon11, _rect80, _rect81, _rect82, _rect83, _polygon12, _rect84, _rect85, _rect86, _path188, _rect87, _rect88, _path189, _path190, _rect89, _path191, _rect90, _path192, _polygon13, _polygon14, _polygon15, _polygon16, _path193, _path194, _path195, _rect91, _polygon17, _path196, _rect92, _rect93, _path197, _rect94, _rect95, _path198, _polygon18, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _rect96, _rect97, _path207, _path208, _rect98, _rect99, _rect100, _path209, _path210, _rect101, _path211, _path212, _path213, _path214, _polygon19, _path215, _path216, _rect102, _path217, _path218, _path219, _path220, _path221, _rect103, _path222, _path223, _path224, _rect104, _path225, _rect105, _circle4, _rect106, _path226, _path227, _path228, _path229, _rect107, _path230, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _path231, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _circle5, _path232, _rect135, _rect136, _path233, _path234, _path235, _path236, _path237, _path238, _rect137, _rect138, _path239, _rect139, _rect140, _rect141, _path240, _rect142, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _rect143, _path249, _rect144, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _rect145, _polygon20, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _circle6, _path269, _path270, _path271, _path272, _rect146, _rect147, _path273, _path274, _rect148, _rect149, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _rect150, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgGraphic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3175 1317.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bg_graphic") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3184.71,1006.15v17.74a9.21,9.21,0,0,0,0-17.74Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 229.69,
    y: 310.92,
    width: 303.5,
    height: 26.02
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 229.69,
    y: 341.95,
    width: 303.5,
    height: 26.02
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 229.69,
    y: 279.9,
    width: 303.5,
    height: 26.02
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 229.69,
    y: 372.97,
    width: 303.5,
    height: 26.02
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "475.22 16.05 475.22 70.49 529.66 70.49 475.22 16.05"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 229.69,
    y: 435.02,
    width: 303.5,
    height: 26.02
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 229.69,
    y: 404,
    width: 303.5,
    height: 26.02
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 229.69,
    y: 124.77,
    width: 303.5,
    height: 26.02
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 229.69,
    y: 93.75,
    width: 303.5,
    height: 26.02
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "646.48 63.05 643.19 63.05 587.19 63.05 583.9 63.05 583.9 86.48 646.48 86.48 646.48 63.05"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 229.69,
    y: 217.85,
    width: 303.5,
    height: 26.02
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 229.69,
    y: 466.05,
    width: 303.5,
    height: 26.02
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 229.69,
    y: 155.8,
    width: 303.5,
    height: 26.02
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M241.05,694.66a76.41,76.41,0,0,0-2.64-27.94c-5.63-18.69-18.41-29.63-38-32.53A59.6,59.6,0,0,0,150.3,650v8.32c9.89-.6,18.86-4.71,23.81-11a2.5,2.5,0,1,1,3.94,3.08c-6.29,8-17.89,13.06-30.25,13.06s-24-5-30.26-13.06a2.5,2.5,0,0,1,3.94-3.08c5,6.34,13.93,10.45,23.82,11v-8.47a59.6,59.6,0,0,0-40.85-16.31,62.22,62.22,0,0,0-9.13.68c-19.58,2.9-32.36,13.84-38,32.53a76.29,76.29,0,0,0-2.63,28c.14.89.3,2,.49,3.37C65.88,772.33,89.34,810.64,124.93,812a39.87,39.87,0,0,0,21.69-5l1.23-.7,1.92,1.07a40.19,40.19,0,0,0,21,4.59c35.59-1.32,59.05-39.63,69.74-113.87C240.74,696.76,240.91,695.61,241.05,694.66Zm-15.76-20.21a6.59,6.59,0,0,1-5,1.92,14.64,14.64,0,0,1-5.2-1.11,37.14,37.14,0,0,1-11.62-7.69c-7.44-7-12.64-16.57-8.18-21.31s14.33-.13,21.77,6.87h0a37.16,37.16,0,0,1,8.38,11.13C228.14,670.12,226.5,673.16,225.29,674.45Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 229.69,
    y: 248.87,
    width: 303.5,
    height: 26.02
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 819.53,
    y: 819.64,
    width: 29,
    height: 19.27
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M848.39,889h210a5.51,5.51,0,0,0,5.5-5.5V656.85h-221V883.49A5.5,5.5,0,0,0,848.39,889Zm155.49-203.15a4.51,4.51,0,0,1,4.5-4.5h30a4.51,4.51,0,0,1,4.5,4.5v30a4.51,4.51,0,0,1-4.5,4.5h-30a4.51,4.51,0,0,1-4.5-4.5Zm0,47.37a4.51,4.51,0,0,1,4.5-4.5h30a4.51,4.51,0,0,1,4.5,4.5v30a4.51,4.51,0,0,1-4.5,4.5h-30a4.51,4.51,0,0,1-4.5-4.5Zm0,47a4.51,4.51,0,0,1,4.5-4.5h30a4.51,4.51,0,0,1,4.5,4.5v77.17a4.51,4.51,0,0,1-4.5,4.5h-30a4.51,4.51,0,0,1-4.5-4.5Zm-46.66-94.33a4.51,4.51,0,0,1,4.5-4.5h30a4.51,4.51,0,0,1,4.5,4.5v30a4.51,4.51,0,0,1-4.5,4.5h-30a4.51,4.51,0,0,1-4.5-4.5Zm0,47.37a4.51,4.51,0,0,1,4.5-4.5h30a4.51,4.51,0,0,1,4.5,4.5v30a4.51,4.51,0,0,1-4.5,4.5h-30a4.51,4.51,0,0,1-4.5-4.5Zm0,47.37a4.51,4.51,0,0,1,4.5-4.5h30a4.51,4.51,0,0,1,4.5,4.5v30a4.51,4.51,0,0,1-4.5,4.5h-30a4.51,4.51,0,0,1-4.5-4.5Zm0,47.37a4.51,4.51,0,0,1,4.5-4.5h30a4.51,4.51,0,0,1,4.5,4.5v30a4.51,4.51,0,0,1-4.5,4.5h-30a4.51,4.51,0,0,1-4.5-4.5ZM910.55,685.84a4.51,4.51,0,0,1,4.5-4.5h30a4.5,4.5,0,0,1,4.5,4.5v30a4.5,4.5,0,0,1-4.5,4.5h-30a4.51,4.51,0,0,1-4.5-4.5Zm0,47.37a4.51,4.51,0,0,1,4.5-4.5h30a4.5,4.5,0,0,1,4.5,4.5v30a4.5,4.5,0,0,1-4.5,4.5h-30a4.51,4.51,0,0,1-4.5-4.5Zm0,47.37a4.51,4.51,0,0,1,4.5-4.5h30a4.5,4.5,0,0,1,4.5,4.5v30a4.5,4.5,0,0,1-4.5,4.5h-30a4.51,4.51,0,0,1-4.5-4.5Zm0,47.37a4.51,4.51,0,0,1,4.5-4.5h30a4.5,4.5,0,0,1,4.5,4.5v30a4.5,4.5,0,0,1-4.5,4.5h-30a4.51,4.51,0,0,1-4.5-4.5ZM863.89,685.84a4.51,4.51,0,0,1,4.5-4.5h30a4.51,4.51,0,0,1,4.5,4.5v30a4.51,4.51,0,0,1-4.5,4.5h-30a4.51,4.51,0,0,1-4.5-4.5Zm0,47.37a4.51,4.51,0,0,1,4.5-4.5h30a4.51,4.51,0,0,1,4.5,4.5v30a4.51,4.51,0,0,1-4.5,4.5h-30a4.51,4.51,0,0,1-4.5-4.5Zm0,47.37a4.51,4.51,0,0,1,4.5-4.5h30a4.51,4.51,0,0,1,4.5,4.5v30a4.51,4.51,0,0,1-4.5,4.5h-30a4.51,4.51,0,0,1-4.5-4.5Zm0,47.37a4.51,4.51,0,0,1,4.5-4.5h30a4.51,4.51,0,0,1,4.5,4.5v30a4.51,4.51,0,0,1-4.5,4.5h-30a4.51,4.51,0,0,1-4.5-4.5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M842.89,651.85h221v-56h-221Zm23.5-16.71h34a2.5,2.5,0,0,1,0,5h-34a2.5,2.5,0,0,1,0-5Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 819.53,
    y: 843.92,
    width: 29,
    height: 4.73
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M687.55,33.74a5.51,5.51,0,0,0-5.5-5.5h-35a5.51,5.51,0,0,0-5.5,5.5V66.85h46ZM652.29,56a2.5,2.5,0,1,1-5,0V39.48a2.5,2.5,0,0,1,5,0Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 819.53,
    y: 772.27,
    width: 29,
    height: 19.27
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1058.39,894h-210a10.38,10.38,0,0,1-5.11-1.34A13.51,13.51,0,0,0,856.39,903h194a13.52,13.52,0,0,0,13.11-10.34A10.44,10.44,0,0,1,1058.39,894Z",
    transform: "translate(-49.36 -8.81)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "604.68 423.5 615.19 431.59 625.7 423.5 625.7 91.58 604.68 91.58 604.68 423.5"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "610.41 480.2 615.19 491.99 619.97 480.2 610.41 480.2"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "592.19 429.54 599.68 423.54 599.68 91.58 592.19 91.58 592.19 429.54"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "630.7 423.54 638.19 429.54 638.19 91.58 630.7 91.58 630.7 423.54"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1050.39,557.65h-194a13.51,13.51,0,0,0-13.5,13.5v19.66h221V571.15A13.52,13.52,0,0,0,1050.39,557.65Z",
    transform: "translate(-49.36 -8.81)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M677.57,436.75h-.07l-13,10-12.94-10h-.07l-9.78,7.83,16,39.43h13.61l16-39.43Z",
    transform: "translate(-49.36 -8.81)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133.06,222.29V61.69a31.36,31.36,0,1,0-62.71,0v160.6ZM87,73.89a14.71,14.71,0,0,1,29.41,0v96.4a4.51,4.51,0,0,1-4.5,4.5h-.41v17.6a9.8,9.8,0,1,1-19.6,0v-17.6h-.4a4.5,4.5,0,0,1-4.5-4.5Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 21.23,
    y: 853.99,
    width: 50.58,
    height: 11.17
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "71.66 875.11 71.66 870.15 21.23 870.15 21.23 879.11 71.66 879.11 71.66 875.11"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.41,73.89a9.71,9.71,0,0,0-19.41,0v95.9h19.41ZM104.2,158.7a2.5,2.5,0,0,1-5,0V78.09a2.5,2.5,0,0,1,5,0Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 30.44,
    y: 1303.45,
    width: 32.16,
    height: 9
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 819.53,
    y: 796.55,
    width: 29,
    height: 4.73
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.21,899.49v-1.67a8.91,8.91,0,0,0-8.9-8.9h-8.13v10.57Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 30.44,
    y: 1075.19,
    width: 32.16,
    height: 223.26
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 30.44,
    y: 1065.05,
    width: 32.16,
    height: 5.14
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153.4,621.16A20.88,20.88,0,0,0,166.92,623c10.52-2.06,21.16-11.93,31-28.67Z",
    transform: "translate(-49.36 -8.81)"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "229.69 12.52 229.69 88.75 533.19 88.75 533.19 75.49 470.22 75.49 470.22 12.52 229.69 12.52"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.13,590.15c-19.32,1-32.91,5.76-39.55,14.11a20.64,20.64,0,0,0-4.57,12.5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M126.18,904.49v24.7a13.77,13.77,0,0,1,6,2.85V914.92a2.5,2.5,0,0,1,5,0v126.67a3,3,0,1,0,6,0V904.49Z",
    transform: "translate(-49.36 -8.81)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M121,933.92v-41H84.18v160.53a2.5,2.5,0,0,1-5,0V892.92H70.59v175.94h50.59V933.92Z",
    transform: "translate(-49.36 -8.81)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M213.68,656.77h0c-5.64-5.3-10.93-7.47-13.42-7.47a1.76,1.76,0,0,0-1.29.38c-1,1.07.49,7.21,8,14.25a32.66,32.66,0,0,0,10,6.67c2.77,1.06,4.35.83,4.74.42s.51-2-.72-4.69A32.76,32.76,0,0,0,213.68,656.77Z",
    transform: "translate(-49.36 -8.81)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.45,105.48a5.43,5.43,0,1,0-5.43-5.42A5.43,5.43,0,0,0,233.45,105.48Z",
    transform: "translate(-49.36 -8.81)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.45,456.92a5.43,5.43,0,1,0,5.43,5.43A5.44,5.44,0,0,0,233.45,456.92Z",
    transform: "translate(-49.36 -8.81)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.45,275.77a5.43,5.43,0,1,0,5.43,5.43A5.44,5.44,0,0,0,233.45,275.77Z",
    transform: "translate(-49.36 -8.81)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M262,21.33h-55V531.49h55Zm-28.59,68.3A10.43,10.43,0,1,1,223,100.06,10.44,10.44,0,0,1,233.45,89.63Zm0,383.14a10.43,10.43,0,1,1,10.43-10.42A10.44,10.44,0,0,1,233.45,472.77Zm0-181.14a10.43,10.43,0,1,1,10.43-10.43A10.44,10.44,0,0,1,233.45,291.63Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 229.69,
    y: 497.07,
    width: 303.5,
    height: 25.61
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 217.68,
    y: 12.52,
    width: 7.01,
    height: 510.16
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.7,500.48a2.71,2.71,0,1,0-2.7-2.71A2.71,2.71,0,0,0,101.7,500.48Z",
    transform: "translate(-49.36 -8.81)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M77.19,254.79V437.58h49V254.79Zm42.45,163.56a2.5,2.5,0,0,1-5,0V393.24a2.5,2.5,0,0,1,5,0Zm0-39.33a2.5,2.5,0,0,1-5,0V267.69a2.5,2.5,0,0,1,5,0Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 20.98,
    y: 218.48,
    width: 62.71,
    height: 8.54
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 35.63,
    y: 433.78,
    width: 33.42,
    height: 21.95
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 27.83,
    y: 232.63,
    width: 49.02,
    height: 8.36
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.55,494.65,99.2,535.74V514.58a2.5,2.5,0,0,1,5,0v21.16l15.65-41.09c-9-2.43-10.53-18.57-10.78-25.12H94.33C94.08,476.08,92.55,492.22,83.55,494.65Zm25.85,3.12a7.7,7.7,0,1,1-7.7-7.7A7.71,7.71,0,0,1,109.4,497.77Z",
    transform: "translate(-49.36 -8.81)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.9,192.39a4.8,4.8,0,0,0,9.6,0v-17.6H96.9Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 229.69,
    y: 186.82,
    width: 303.5,
    height: 26.02
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1280.77,407.43l24.71,7.74a44.27,44.27,0,0,0,44.91-14.65l17.31-23.12h-88.33a39.27,39.27,0,0,1,1.4,30Z",
    transform: "translate(-49.36 -8.81)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1243,382.07a14.43,14.43,0,0,1,14.41,14.41,14.05,14.05,0,0,1-.45,3.5l19,6a34.32,34.32,0,1,0-65.43-20.49l19,5.94A14.46,14.46,0,0,1,1243,382.07Z",
    transform: "translate(-49.36 -8.81)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1372.05,76.13V69.34a.5.5,0,0,0-.5-.5h-44.89a.5.5,0,0,0-.5.5v6.79Z",
    transform: "translate(-49.36 -8.81)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1379,86.63a5.51,5.51,0,0,0-5.5-5.5h-2.75V94.87a2.5,2.5,0,0,1-5,0V81.13h-25.22V94.87a2.5,2.5,0,1,1-5,0V81.13h-4.77V94.87a2.5,2.5,0,1,1-5,0V81.13h-1.09a5.51,5.51,0,0,0-5.5,5.5v15H1379Z",
    transform: "translate(-49.36 -8.81)"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1093.09 479.58 1100.71 495.53 1329.54 495.53 1337.16 479.58 1335.63 479.58 1094.63 479.58 1093.09 479.58"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1243,387.07a9.43,9.43,0,0,0-8.7,5.82l17.89,5.6a9.59,9.59,0,0,0,.22-2A9.42,9.42,0,0,0,1243,387.07Z",
    transform: "translate(-49.36 -8.81)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1288.76,319.06h120.69a13.51,13.51,0,0,0,13.5-13.5V274.1h-79.57a4.5,4.5,0,0,1-4.5-4.5V151.94a4.51,4.51,0,0,1,4.5-4.5H1423V120.1a13.51,13.51,0,0,0-13.5-13.5H1288.76a13.51,13.51,0,0,0-13.5,13.5V305.56A13.51,13.51,0,0,0,1288.76,319.06Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1099.63,
    y: 466.57,
    width: 231,
    height: 8.01
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M851,189.34a3.71,3.71,0,0,1,2.72,1.2l14.2,15.36V29.06s0,0,0-.07,0,0,0-.08V16.81H834.07v189.1l14.2-15.37A3.74,3.74,0,0,1,851,189.34Z",
    transform: "translate(-49.36 -8.81)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1135.41,883.08H1151V578.45h-15.58a5.5,5.5,0,0,0-5.5,5.5V877.58A5.5,5.5,0,0,0,1135.41,883.08Z",
    transform: "translate(-49.36 -8.81)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1385,470.38h3v-93h-14l-19.65,26.26A49.33,49.33,0,0,1,1304.17,420l-.12,0L1170.3,378.08l-28.6,92.3H1385ZM1160.82,453.9h46.84a2.5,2.5,0,0,1,0,5h-46.84a2.5,2.5,0,0,1,0-5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1030.29,104.24H1016.1a4.87,4.87,0,0,1-4.64-3.37l-4.38-13.49a2.25,2.25,0,0,0-4.28,0l-4.38,13.49a4.87,4.87,0,0,1-4.64,3.37H979.59a2.25,2.25,0,0,0-1.32,4.07l11.48,8.34a4.87,4.87,0,0,1,1.77,5.45l-4.39,13.49a2.25,2.25,0,0,0,3.46,2.52l11.48-8.34a4.84,4.84,0,0,1,5.73,0l11.48,8.34a2.25,2.25,0,0,0,3.46-2.52l-4.38-13.49a4.84,4.84,0,0,1,1.77-5.45l11.48-8.34a2.25,2.25,0,0,0-1.32-4.07Z",
    transform: "translate(-49.36 -8.81)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1169.49,883.08h156.75a27.53,27.53,0,0,0,27.5-27.5V606a27.53,27.53,0,0,0-27.5-27.5H1169.49Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1106.63,
    y: 569.86,
    width: 8.5,
    height: 304.19
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1423,653.48V826.89h63V653.48h-8.92v67.73a2.5,2.5,0,0,1-5,0V653.48Z",
    transform: "translate(-49.36 -8.81)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1472.18,876.55a2.6,2.6,0,0,1-.07-.56V853.15h-21V876a2.1,2.1,0,0,1-.07.56Z",
    transform: "translate(-49.36 -8.81)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1548.37,485.1h-31a2.5,2.5,0,0,1,0-5h31V464.54H1533a2.5,2.5,0,0,1,0-5h15.37v-14.1H1533a2.5,2.5,0,0,1,0-5h15.37V426.33H1533a2.5,2.5,0,0,1,0-5h15.37V407.22H1533a2.5,2.5,0,0,1,0-5h15.37V386.66h-31a2.5,2.5,0,0,1,0-5h31V366.11H1533a2.5,2.5,0,0,1,0-5h15.37V347H1533a2.5,2.5,0,0,1,0-5h15.37V327.89H1533a2.5,2.5,0,0,1,0-5h15.37v-14.1H1533a2.5,2.5,0,0,1,0-5h15.37V288.23h-31a2.5,2.5,0,0,1,0-5h31V267.67H1533a2.5,2.5,0,0,1,0-5h15.37V248.56H1533a2.5,2.5,0,0,1,0-5h15.37v-14.1H1533a2.5,2.5,0,0,1,0-5h15.37V210.35H1533a2.5,2.5,0,0,1,0-5h15.37V189.79h-31a2.5,2.5,0,0,1,0-5h31V169.24H1533a2.5,2.5,0,0,1,0-5h15.37V150.13H1533a2.5,2.5,0,0,1,0-5h15.37V131H1533a2.5,2.5,0,1,1,0-5h15.37v-14.1H1533a2.5,2.5,0,0,1,0-5h15.37V91.36h-31a2.5,2.5,0,0,1,0-5h31v-63h-79v496h79ZM1497.87,50a11,11,0,1,1,11,11A11,11,0,0,1,1497.87,50Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1373.67,
    y: 833.71,
    width: 63,
    height: 5.63
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1055.93,61.19h-102v102h102Zm-21.38,51.16-11.41,8.29,4.36,13.41a7.25,7.25,0,0,1-11.16,8.1l-11.4-8.29-11.41,8.29a7.14,7.14,0,0,1-8.52,0,7.13,7.13,0,0,1-2.63-8.1l4.36-13.41-11.41-8.29a7.25,7.25,0,0,1,4.26-13.11h14.1l4.36-13.41a7.24,7.24,0,0,1,13.78,0l4.36,13.41h14.1a7.25,7.25,0,0,1,4.26,13.11Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 819.53,
    y: 724.9,
    width: 29,
    height: 19.27
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1459.5,
    cy: 41.19,
    r: 6
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1373.67,
    y: 633.64,
    width: 63,
    height: 6.03
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1423,637.45h63V604.22a16.41,16.41,0,0,0-16.39-16.39h-30.22A16.41,16.41,0,0,0,1423,604.22Z",
    transform: "translate(-49.36 -8.81)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1477.11,853.15V876a2.6,2.6,0,0,1-.06.56h9v-23.4Z",
    transform: "translate(-49.36 -8.81)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1360.37,36.89A11.31,11.31,0,0,0,1358,30l-5.27-6.8a4.54,4.54,0,0,0-1.14-1.05v20.4a2.5,2.5,0,0,1-5,0V22.15a4.72,4.72,0,0,0-1.14,1.05L1340.2,30a11.31,11.31,0,0,0-2.36,6.89v26.8h22.53Z",
    transform: "translate(-49.36 -8.81)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1343.88,269.1H1423V177.29h-60.08a2.5,2.5,0,0,1,0-5H1423V152.44h-79.07Zm19-63h45.85a2.5,2.5,0,0,1,0,5h-45.85a2.5,2.5,0,0,1,0-5Zm0,16.44h45.85a2.5,2.5,0,0,1,0,5h-45.85a2.5,2.5,0,0,1,0-5Zm0,16.44h45.85a2.5,2.5,0,0,1,0,5h-45.85a2.5,2.5,0,0,1,0-5Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1373.67,
    y: 823.08,
    width: 63,
    height: 5.63
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1446.12,876V853.15H1423v23.4h23.16A2.6,2.6,0,0,1,1446.12,876Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 866.19,
    y: 677.53,
    width: 29,
    height: 19.27
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 866.19,
    y: 796.55,
    width: 29,
    height: 4.73
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 912.86,
    y: 843.92,
    width: 29,
    height: 4.73
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 866.19,
    y: 749.18,
    width: 29,
    height: 4.73
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 866.19,
    y: 701.81,
    width: 29,
    height: 4.73
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 912.86,
    y: 819.64,
    width: 29,
    height: 19.27
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 866.19,
    y: 724.9,
    width: 29,
    height: 19.27
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 866.19,
    y: 772.27,
    width: 29,
    height: 19.27
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 819.53,
    y: 701.81,
    width: 29,
    height: 4.73
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 819.53,
    y: 749.18,
    width: 29,
    height: 4.73
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 819.53,
    y: 677.53,
    width: 29,
    height: 19.27
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 866.19,
    y: 843.92,
    width: 29,
    height: 4.73
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 866.19,
    y: 819.64,
    width: 29,
    height: 19.27
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 959.52,
    y: 724.9,
    width: 29,
    height: 19.27
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 959.52,
    y: 677.53,
    width: 29,
    height: 19.27
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 959.52,
    y: 749.18,
    width: 29,
    height: 4.73
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M808.92,31.49V485.16h257.51a17.52,17.52,0,0,0,17.5-17.5V49a17.52,17.52,0,0,0-17.5-17.5H872.91V208.21a4.44,4.44,0,0,1-2.64,4.25,3.6,3.6,0,0,1-4-1h0L851,195l-15.26,16.52a3.69,3.69,0,0,1-2.71,1.23,3.53,3.53,0,0,1-1.3-.25,4.43,4.43,0,0,1-2.65-4.25V31.49Zm140,29.2a4.51,4.51,0,0,1,4.5-4.5h103a4.5,4.5,0,0,1,4.5,4.5v103a4.5,4.5,0,0,1-4.5,4.5h-103a4.51,4.51,0,0,1-4.5-4.5Zm-12,12a2.5,2.5,0,0,1,5,0V175.2h102.49a2.5,2.5,0,0,1,0,5h-103a4.51,4.51,0,0,1-4.5-4.5Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 959.52,
    y: 843.92,
    width: 29,
    height: 4.11
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 959.52,
    y: 701.81,
    width: 29,
    height: 4.73
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 912.86,
    y: 772.27,
    width: 29,
    height: 19.27
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 912.86,
    y: 749.18,
    width: 29,
    height: 4.73
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 912.86,
    y: 724.9,
    width: 29,
    height: 19.27
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 912.86,
    y: 796.55,
    width: 29,
    height: 4.73
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 912.86,
    y: 677.53,
    width: 29,
    height: 19.27
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 912.86,
    y: 701.81,
    width: 29,
    height: 4.73
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 959.52,
    y: 771.86,
    width: 29,
    height: 67.06
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 750.55,
    y: 22.68,
    width: 4.01,
    height: 453.67
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 712.73,
    y: 654.66,
    width: 11.63,
    height: 256
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1392.98,
    cy: 1248.83,
    r: 23.9
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M625.55,1221.71v-31.18a112.47,112.47,0,0,0-109.8,109.79h31.19A81.24,81.24,0,0,1,625.55,1221.71Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 397.52,
    y: 996.26,
    width: 11.63,
    height: 51
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 630.32,
    y: 996.26,
    width: 11.63,
    height: 51
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M542.06,1137.13h125.1v-51H542.06Zm62.55-43c21.82,0,45,6.13,45,17.5s-23.2,17.5-45,17.5-45-6.13-45-17.5S582.79,1094.13,604.61,1094.13Z",
    transform: "translate(-49.36 -8.81)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1589.59,769a30.9,30.9,0,1,0-21.84,9A30.68,30.68,0,0,0,1589.59,769Zm-38-21.85a16.21,16.21,0,0,1,27.67-11.46h0a16.21,16.21,0,1,1-27.67,11.46Z",
    transform: "translate(-49.36 -8.81)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M630.55,1190.53v31.18a81.26,81.26,0,0,1,78.61,78.61h31.18A112.46,112.46,0,0,0,630.55,1190.53Z",
    transform: "translate(-49.36 -8.81)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M630.55,1226.71v73.61h73.63A76.26,76.26,0,0,0,630.55,1226.71Z",
    transform: "translate(-49.36 -8.81)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M625.55,1226.71a76.26,76.26,0,0,0-73.64,73.61h73.64Z",
    transform: "translate(-49.36 -8.81)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1563.61,808.93h-10.36a1.5,1.5,0,0,0-1.5,1.5v205.64a1.57,1.57,0,0,0,.22.79l10.36,16.94a1.5,1.5,0,0,0,2.78-.79V810.43A1.5,1.5,0,0,0,1563.61,808.93Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 446.18,
    y: 996.26,
    width: 6.01,
    height: 51
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 433.03,
    y: 1077.32,
    width: 11.63,
    height: 51
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M726.83,1038v-14.85a1.51,1.51,0,0,0-1.33-1.49l-29-3.29v24.41l29-3.29A1.51,1.51,0,0,0,726.83,1038Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 598.3,
    y: 996.26,
    width: 27.03,
    height: 51
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 665.83,
    y: 1077.32,
    width: 11.63,
    height: 51
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 587.29,
    y: 996.26,
    width: 6.01,
    height: 51
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M631.65,1005.06H506.55v51h125.1Zm-62.55,43c-21.82,0-45-6.13-45-17.5s23.2-17.5,45-17.5,45,6.14,45,17.5S590.92,1048.06,569.1,1048.06Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 414.15,
    y: 996.26,
    width: 27.03,
    height: 51
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M569.1,1018.06c-24.8,0-40,7.28-40,12.5s15.22,12.5,40,12.5,40-7.28,40-12.5S593.89,1018.06,569.1,1018.06Z",
    transform: "translate(-49.36 -8.81)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1483.84,1139.64V999a22.54,22.54,0,0,0-20,22.36v118.33Z",
    transform: "translate(-49.36 -8.81)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M837.51,1267.3h187.86a38,38,0,0,0-37.91-35.5l-153.45,0v16.43a2.49,2.49,0,0,1,.87-.16h154a2.5,2.5,0,1,1,0,5h-154a2.49,2.49,0,0,1-.87-.17v10.93A3.5,3.5,0,0,0,837.51,1267.3Z",
    transform: "translate(-49.36 -8.81)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1245.57,1302.17H811.18a12.39,12.39,0,0,1-7.5-2.53v3a7.51,7.51,0,0,0,7.5,7.5h434.39a7.52,7.52,0,0,0,7.5-7.5v-3A12.43,12.43,0,0,1,1245.57,1302.17Z",
    transform: "translate(-49.36 -8.81)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M665.86,564.34a1.5,1.5,0,0,0-1.85-.76L513.22,616.79H691.13Z",
    transform: "translate(-49.36 -8.81)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1031.37,1267.3h187.87a3.5,3.5,0,0,0,3.5-3.5V1253H1069.06a2.5,2.5,0,0,1,0-5h153.68v-16.27l-153.46,0A38,38,0,0,0,1031.37,1267.3Z",
    transform: "translate(-49.36 -8.81)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1603.64,999.34v17.75a9.22,9.22,0,0,0,0-17.75Z",
    transform: "translate(-49.36 -8.81)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1066.78,1226.87v-.07l2.5,0h153.46V983.87a3.5,3.5,0,0,0-3.5-3.5h-150a38,38,0,0,0-38,38v231.32A43.08,43.08,0,0,1,1066.78,1226.87Zm78.47-23.25h-44.16a2.5,2.5,0,0,1,0-5h44.16a2.5,2.5,0,0,1,0,5Zm-81.19-195.15h76.11a2.5,2.5,0,0,1,0,5h-76.11a2.5,2.5,0,0,1,0-5Zm0,16h126.15a2.5,2.5,0,0,1,0,5H1064.06a2.5,2.5,0,0,1,0-5Zm0,16h105.22a2.5,2.5,0,0,1,0,5H1064.06a2.5,2.5,0,0,1,0-5Zm0,16h126.15a2.5,2.5,0,0,1,0,5H1064.06a2.5,2.5,0,0,1,0-5Zm-2.5,31.57a6.51,6.51,0,0,1,6.5-6.5h118.15a6.5,6.5,0,0,1,6.5,6.5v93.83a6.5,6.5,0,0,1-6.5,6.5H1068.06a6.51,6.51,0,0,1-6.5-6.5Zm2.5,110.54h18.16a2.5,2.5,0,1,1,0,5h-18.16a2.5,2.5,0,0,1,0-5Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 817.04,
    y: 1011.25,
    width: 125.4,
    height: 20.44,
    rx: 1.5,
    ry: 1.5
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M990,1226.87a43.08,43.08,0,0,1,35.51,22.82V1018.37a38,38,0,0,0-38-38h-150a3.5,3.5,0,0,0-3.5,3.5v242.9H990ZM861.4,1021.55a6.51,6.51,0,0,1,6.5-6.5H990.3a6.51,6.51,0,0,1,6.5,6.5V1039a6.51,6.51,0,0,1-6.5,6.5H867.9a6.51,6.51,0,0,1-6.5-6.5Zm2.5,52H940a2.5,2.5,0,0,1,0,5H863.9a2.5,2.5,0,0,1,0-5Zm0,16H990.05a2.5,2.5,0,0,1,0,5H863.9a2.5,2.5,0,1,1,0-5Zm0,16H969.12a2.5,2.5,0,1,1,0,5H863.9a2.5,2.5,0,1,1,0-5Zm0,16H990.05a2.5,2.5,0,0,1,0,5H863.9a2.5,2.5,0,0,1,0-5Zm0,16H980.05a2.5,2.5,0,0,1,0,5H863.9a2.5,2.5,0,1,1,0-5Zm0,16H990.05a2.5,2.5,0,1,1,0,5H863.9a2.5,2.5,0,0,1,0-5Zm0,16H969.12a2.5,2.5,0,0,1,0,5H863.9a2.5,2.5,0,0,1,0-5Zm0,21a2.5,2.5,0,1,1,0-5H990.05a2.5,2.5,0,0,1,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1017.2,
    y: 1077.77,
    width: 121.15,
    height: 96.84,
    rx: 1.5,
    ry: 1.5
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M811.18,1297.17h434.39a7.52,7.52,0,0,0,7.5-7.5V1016.88a7.51,7.51,0,0,0-7.5-7.5h-17.83V1263.8a8.51,8.51,0,0,1-8.5,8.5H837.51a8.51,8.51,0,0,1-8.5-8.5V1009.38H811.18a7.5,7.5,0,0,0-7.5,7.5v272.79A7.51,7.51,0,0,0,811.18,1297.17Z",
    transform: "translate(-49.36 -8.81)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1571.89,803.93h2.68V782.4a36.18,36.18,0,0,1-14-.07v21.6h3a6.46,6.46,0,0,0,8.28,0Z",
    transform: "translate(-49.36 -8.81)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1570.39,1103.07a1.43,1.43,0,0,0,1.1,1.44,1.4,1.4,0,0,0,1.68-.66l10.36-16.94a1.5,1.5,0,0,0,.22-.78v-48.08h-13.36Z",
    transform: "translate(-49.36 -8.81)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1395,938.61h-68.26v203.44H1395a3.5,3.5,0,0,0,3.5-3.5V942.11A3.5,3.5,0,0,0,1395,938.61Z",
    transform: "translate(-49.36 -8.81)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1488.84,1139.64h20V1021.31a22.54,22.54,0,0,0-20-22.36Z",
    transform: "translate(-49.36 -8.81)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M322.19,688H524.56V650H322.19Zm9.49-27.51H439.19a2.5,2.5,0,1,1,0,5H331.68a2.5,2.5,0,0,1,0-5Zm0,12h155a2.5,2.5,0,1,1,0,5h-155a2.5,2.5,0,0,1,0-5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M784.58,638H762.09v20.52h12.12a4.51,4.51,0,0,1,4.5,4.5V920a4.51,4.51,0,0,1-4.5,4.5H762.09v11.79a14.67,14.67,0,0,0,4.4,10.42,13.72,13.72,0,0,0,9.86,4,14.06,14.06,0,0,0,13.73-14V643.45A5.5,5.5,0,0,0,784.58,638Z",
    transform: "translate(-49.36 -8.81)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1586.91,1008.22a14.25,14.25,0,0,1,11.73-14V983.38h-28.25v49.67h28.25v-10.84A14.24,14.24,0,0,1,1586.91,1008.22Z",
    transform: "translate(-49.36 -8.81)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M757.09,936.26V924.47h0v-266h0V627.29a5.5,5.5,0,0,0-5.5-5.5H446.07a4.52,4.52,0,0,1-4.21-2.93l-9.67-25.8H356.25v24.23a4.51,4.51,0,0,1-4.5,4.5H302.54a5.5,5.5,0,0,0-5.5,5.5v309.4a14,14,0,0,0,14,14H763.45c-.16-.14-.31-.29-.46-.44A19.73,19.73,0,0,1,757.09,936.26ZM369.36,607H422a2.5,2.5,0,0,1,0,5H369.36a2.5,2.5,0,0,1,0-5Zm160.2,81.5a4.51,4.51,0,0,1-4.5,4.5H321.69a4.51,4.51,0,0,1-4.5-4.5v-39a4.51,4.51,0,0,1,4.5-4.5H525.06a4.51,4.51,0,0,1,4.5,4.5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1321.75,938.61h-6.18a3.5,3.5,0,0,0-3.5,3.5v196.44a3.5,3.5,0,0,0,3.5,3.5h6.18Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 149.41,
    y: 950.98,
    width: 18.81,
    height: 118.33
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "315.44 1060.41 260.61 1060.41 260.61 1110.23 315.44 1124.28 315.44 1060.41"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1530.34,1216.13a41.19,41.19,0,0,0-17.92,4.06l-3.58,1.72v-77.27h-20v12.19a17.31,17.31,0,0,1,0,34.27v63.18h0l0,2.91c0,.15,0,.3,0,.44a41.5,41.5,0,1,0,41.5-41.5Zm0,70.4a28.9,28.9,0,1,1,28.9-28.9A28.93,28.93,0,0,1,1530.34,1286.53Z",
    transform: "translate(-49.36 -8.81)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1591.91,1008.22a9.23,9.23,0,0,0,6.73,8.87V999.34A9.25,9.25,0,0,0,1591.91,1008.22Z",
    transform: "translate(-49.36 -8.81)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1579.41,713.21v-38h-23.32v38a36.19,36.19,0,0,1,23.32,0Z",
    transform: "translate(-49.36 -8.81)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1561.8,756.65a11.2,11.2,0,0,0,13.88-1.56,11.23,11.23,0,0,0,1.56-13.88Z",
    transform: "translate(-49.36 -8.81)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M381.11,1242.81A24.17,24.17,0,1,0,405.28,1267,24.19,24.19,0,0,0,381.11,1242.81Zm2,40.91a2.5,2.5,0,0,1,0-5,9.33,9.33,0,0,0,9.32-9.33,2.5,2.5,0,0,1,5,0A14.35,14.35,0,0,1,383.12,1283.72Z",
    transform: "translate(-49.36 -8.81)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.77,908.13c.31,0,.62,0,.92,0h7.59l1.43-8.37H204.33l1.44,8.37h7.58c.31,0,.61,0,.92,0Z",
    transform: "translate(-49.36 -8.81)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1572.39,646.84a4.64,4.64,0,0,0-9.28,0v23.39h9.28Z",
    transform: "translate(-49.36 -8.81)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.69,913.18H213.35a15.51,15.51,0,0,0-14.58,15.45v26.16h23.82v128.33H198.77v41.65h47.5V928.63A15.51,15.51,0,0,0,231.69,913.18Zm6.75,151.29a2.5,2.5,0,0,1-5,0V972.86a2.5,2.5,0,0,1,5,0Zm0-105.27a2.5,2.5,0,0,1-5,0V929.83a2.5,2.5,0,0,1,5,0Z",
    transform: "translate(-49.36 -8.81)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M376.35,1205.94a16.17,16.17,0,1,0-16.16,16.16A16.18,16.18,0,0,0,376.35,1205.94Z",
    transform: "translate(-49.36 -8.81)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1480.98,
    cy: 1248.83,
    r: 23.9
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M317.27,1227.14a11.17,11.17,0,1,0,11.17,11.17A11.18,11.18,0,0,0,317.27,1227.14Z",
    transform: "translate(-49.36 -8.81)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1571.89,808.93a1.5,1.5,0,0,0-1.5,1.5v168h13.36v-168a1.5,1.5,0,0,0-1.5-1.5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1483.83,1257.22l0-2.94h.06V1191.1a17.31,17.31,0,0,1,0-34.27v-12.19h-20v77.27l-3.58-1.72a41.51,41.51,0,1,0,23.58,37.44C1483.84,1257.49,1483.83,1257.36,1483.83,1257.22Zm-41.49,29.31a28.9,28.9,0,1,1,28.9-28.9A28.93,28.93,0,0,1,1442.34,1286.53Z",
    transform: "translate(-49.36 -8.81)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M367,1161.26a12.44,12.44,0,0,1-2.24-7.15v-15.86l-54.83-14v29.91a12.51,12.51,0,0,1-2.24,7.15L216,1292.9a17.5,17.5,0,0,0,15.35,25.9h212a17.5,17.5,0,0,0,15.35-25.9ZM245.25,1281.47a2.45,2.45,0,0,1-1.43-.45,2.5,2.5,0,0,1-.62-3.48l65.49-94a2.5,2.5,0,0,1,4.1,2.86l-65.49,94A2.48,2.48,0,0,1,245.25,1281.47Zm72-27a16.17,16.17,0,1,1,16.17-16.17A16.19,16.19,0,0,1,317.27,1254.48ZM339,1205.94a21.17,21.17,0,1,1,21.17,21.16A21.19,21.19,0,0,1,339,1205.94Zm42.09,90.21A29.17,29.17,0,1,1,410.28,1267,29.2,29.2,0,0,1,381.11,1296.15Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 622.8,
    y: 1077.32,
    width: 6.01,
    height: 51
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 481.68,
    y: 1077.32,
    width: 6.01,
    height: 51
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M604.61,1124.13c24.79,0,40-7.28,40-12.5s-15.23-12.5-40-12.5-40,7.28-40,12.5S579.81,1124.13,604.61,1124.13Z",
    transform: "translate(-49.36 -8.81)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.44,851.45a1.5,1.5,0,0,0-1.5-1.5H213.1a1.5,1.5,0,0,0-1.5,1.5v10.1h21.84Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 633.81,
    y: 1077.32,
    width: 27.03,
    height: 51
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 449.66,
    y: 1077.32,
    width: 27.03,
    height: 51
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1498.67,1174a12.33,12.33,0,1,0-12.33,12.34A12.34,12.34,0,0,0,1498.67,1174Zm-6.94-2.57-8.5,8.5a2.49,2.49,0,0,1-1.77.73,2.45,2.45,0,0,1-1.76-.73,2.49,2.49,0,0,1,0-3.53l8.5-8.5a2.5,2.5,0,1,1,3.53,3.53Z",
    transform: "translate(-49.36 -8.81)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1573.71,737.68a11.2,11.2,0,0,0-15.45,15.44Z",
    transform: "translate(-49.36 -8.81)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M367.43,1064.2a10.37,10.37,0,1,0,0-20.74H307.34a10.37,10.37,0,0,0-10,7.87h42.79a2.5,2.5,0,0,1,0,5H297.29a10.37,10.37,0,0,0,10,7.87Zm-15.38-12.87h16.59a2.5,2.5,0,0,1,0,5H352.05a2.5,2.5,0,1,1,0-5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M241.56,894.81l4.7-27.46a.68.68,0,0,0-.68-.8H199.46a.69.69,0,0,0-.53.24.74.74,0,0,0-.15.56l4.7,27.46Z",
    transform: "translate(-49.36 -8.81)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M446.88,1104.2v14.85a1.49,1.49,0,0,0,1.33,1.49l29,3.29v-24.4l-29,3.28A1.5,1.5,0,0,0,446.88,1104.2Z",
    transform: "translate(-49.36 -8.81)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.85,240.83h2.34V438.08a4.51,4.51,0,0,0,4.5,4.5H80V465a4.51,4.51,0,0,0,4.5,4.5h4.84C89,477,87.07,488.83,82,489.88a4.54,4.54,0,0,0-3.1,2.28,4.47,4.47,0,0,0-.26,3.73l18.9,49.61h8.26l18.9-49.61a4.47,4.47,0,0,0-.26-3.73,4.54,4.54,0,0,0-3.1-2.28c-5-1.05-7-12.88-7.3-20.35h4.84a4.51,4.51,0,0,0,4.5-4.5V442.58h3.3a4.51,4.51,0,0,0,4.5-4.5V240.83h2.35a4.51,4.51,0,0,0,4.5-4.5V61.69a36.36,36.36,0,1,0-72.71,0V236.33A4.5,4.5,0,0,0,69.85,240.83Zm56.36,9h-49v-8.35h49Zm-6.36,244.86L104.2,535.74V514.58a2.5,2.5,0,0,0-5,0v21.16L83.55,494.65c9-2.43,10.53-18.57,10.78-25.12h14.74C109.32,476.08,110.85,492.22,119.85,494.65Zm-1.44-30.12H85V442.58h33.42Zm5-26.95H77.19V254.79h49V437.58ZM70.35,235.83v-8.54h62.71v8.54ZM101.7,30.33a31.4,31.4,0,0,1,31.36,31.36v160.6H70.35V61.69A31.39,31.39,0,0,1,101.7,30.33Z",
    transform: "translate(-49.36 -8.81)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94,497.77a7.7,7.7,0,1,0,7.7-7.7A7.71,7.71,0,0,0,94,497.77Zm7.7-2.7a2.71,2.71,0,1,1-2.7,2.7A2.7,2.7,0,0,1,101.7,495.07Z",
    transform: "translate(-49.36 -8.81)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.5,174.79h.4v17.6a9.8,9.8,0,1,0,19.6,0v-17.6h.41a4.51,4.51,0,0,0,4.5-4.5V73.89a14.71,14.71,0,0,0-29.41,0v96.4A4.5,4.5,0,0,0,91.5,174.79Zm15,17.6a4.8,4.8,0,0,1-9.6,0v-17.6h9.6ZM92,73.89a9.71,9.71,0,0,1,19.41,0v95.9H92Z",
    transform: "translate(-49.36 -8.81)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.7,75.59a2.5,2.5,0,0,0-2.5,2.5V158.7a2.5,2.5,0,0,0,5,0V78.09A2.5,2.5,0,0,0,101.7,75.59Z",
    transform: "translate(-49.36 -8.81)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.14,265.19a2.5,2.5,0,0,0-2.5,2.5V379a2.5,2.5,0,0,0,5,0V267.69A2.5,2.5,0,0,0,117.14,265.19Z",
    transform: "translate(-49.36 -8.81)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.14,390.74a2.5,2.5,0,0,0-2.5,2.5v25.11a2.5,2.5,0,0,0,5,0V393.24A2.5,2.5,0,0,0,117.14,390.74Z",
    transform: "translate(-49.36 -8.81)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.57,536.49H583.06a4.51,4.51,0,0,0,4.5-4.5V82.62a3,3,0,0,0,0-.42,1.75,1.75,0,0,0,0-.4,2.48,2.48,0,0,0-1.06-2,4,4,0,0,0-.26-.32l-61.8-61.8-.32-.26a2.47,2.47,0,0,0-2-1.05,2.71,2.71,0,0,0-.41,0,3,3,0,0,0-.42,0H206.57a4.49,4.49,0,0,0-4.5,4.5V532A4.5,4.5,0,0,0,206.57,536.49Zm72.48-92.66H582.56v26H279.05Zm0-5v-26H582.56v26Zm0-31v-26H582.56v26Zm0-31v-26H582.56v26Zm0-31v-26H582.56v26Zm0-31v-26H582.56v26Zm0-31v-26H582.56v26Zm0-31v-26H582.56v26Zm0-31v-26H582.56v26Zm0-31v-26H582.56v26Zm0-31v-26H582.56v26Zm0-31v-26H582.56v26Zm0,346.27H582.56v26H279.05Zm245.54-450L579,79.3H524.59Zm58,59.44V97.56H279.05V21.33H519.59v63ZM274.05,531.49h-7V21.33h7Zm5,0V505.88H582.56v25.61Zm-72-510.16h55V531.49h-55Z",
    transform: "translate(-49.36 -8.81)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M233.45,110.48A10.43,10.43,0,1,0,223,100.06,10.44,10.44,0,0,0,233.45,110.48Zm0-15.85a5.43,5.43,0,1,1-5.43,5.43A5.44,5.44,0,0,1,233.45,94.63Z",
    transform: "translate(-49.36 -8.81)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M233.45,270.77a10.43,10.43,0,1,0,10.43,10.43A10.44,10.44,0,0,0,233.45,270.77Zm0,15.86a5.43,5.43,0,1,1,5.43-5.43A5.44,5.44,0,0,1,233.45,286.63Z",
    transform: "translate(-49.36 -8.81)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M233.45,451.92a10.43,10.43,0,1,0,10.43,10.43A10.44,10.44,0,0,0,233.45,451.92Zm0,15.85a5.43,5.43,0,1,1,5.43-5.42A5.43,5.43,0,0,1,233.45,467.77Z",
    transform: "translate(-49.36 -8.81)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M632.76,100.29h3.79V445l16.71,41.21a2.28,2.28,0,0,0,0,.26,2.48,2.48,0,0,0,.9,1.91l6.3,15.54.07.16a4.51,4.51,0,0,0,8.09,0l6.36-15.7a2.47,2.47,0,0,0,.91-1.91c0-.09,0-.18,0-.27l16.52-40.75.18-.45V100.29h3.8a4.51,4.51,0,0,0,4.5-4.5V71.35a4.51,4.51,0,0,0-4.5-4.5h-3.8V33.74a10.51,10.51,0,0,0-10.5-10.5h-35a10.51,10.51,0,0,0-10.5,10.5V66.85h-3.79a4.51,4.51,0,0,0-4.5,4.5V95.79A4.51,4.51,0,0,0,632.76,100.29Zm54.79,338-7.49-6V100.39h7.49ZM671.36,484H657.75l-16-39.43,9.78-7.83h.07l12.94,10,13-10h.07l9.77,7.83ZM649,432.34l-7.49,6V100.39H649Zm26,0-10.51,8.08L654,432.31V100.39h21ZM664.55,500.8,659.77,489h9.56Zm-23-467.06a5.51,5.51,0,0,1,5.5-5.5h35a5.51,5.51,0,0,1,5.5,5.5V66.85h-46Zm-8.29,38.11h62.59V95.29H633.26Z",
    transform: "translate(-49.36 -8.81)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M649.79,37a2.5,2.5,0,0,0-2.5,2.5V56a2.5,2.5,0,1,0,5,0V39.48A2.5,2.5,0,0,0,649.79,37Z",
    transform: "translate(-49.36 -8.81)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M851,189.34a3.71,3.71,0,0,1,2.72,1.2l14.2,15.36V29.06s0,0,0-.07,0,0,0-.08V16.81H834.07v189.1l14.2-15.37A3.74,3.74,0,0,1,851,189.34Z",
    transform: "translate(-49.36 -8.81)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M768.91,53.49h8.59a2.5,2.5,0,0,1,0,5h-8.59v22h8.59a2.5,2.5,0,0,1,0,5h-8.59v22h8.59a2.5,2.5,0,0,1,0,5h-8.59v22h8.59a2.5,2.5,0,0,1,0,5h-8.59v22h8.59a2.5,2.5,0,0,1,0,5h-8.59v22h8.59a2.5,2.5,0,0,1,0,5h-8.59v22h8.59a2.5,2.5,0,0,1,0,5h-8.59v22h8.59a2.5,2.5,0,0,1,0,5h-8.59v22h8.59a2.5,2.5,0,0,1,0,5h-8.59v22h8.59a2.5,2.5,0,0,1,0,5h-8.59v22h8.59a2.5,2.5,0,0,1,0,5h-8.59v22h8.59a2.5,2.5,0,0,1,0,5h-8.59v22h8.59a2.5,2.5,0,0,1,0,5h-8.59v22h8.59a2.5,2.5,0,0,1,0,5h-8.59v22h8.59a2.5,2.5,0,0,1,0,5h-8.59v22h8.59a2.5,2.5,0,0,1,0,5h-8.59v22h26V31.49h-26Z",
    transform: "translate(-49.36 -8.81)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1066.43,31.49H872.91V208.21a4.44,4.44,0,0,1-2.64,4.25,3.6,3.6,0,0,1-4-1h0L851,195l-15.26,16.52a3.69,3.69,0,0,1-2.71,1.23,3.53,3.53,0,0,1-1.3-.25,4.43,4.43,0,0,1-2.65-4.25V31.49H808.92V485.16h257.51a17.52,17.52,0,0,0,17.5-17.5V49A17.52,17.52,0,0,0,1066.43,31.49Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 750.55,
    y: 22.68,
    width: 4.01,
    height: 453.67
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1066.43,26.49H872.91V16.31a4.5,4.5,0,0,0-4.5-4.5H833.57a4.5,4.5,0,0,0-4.5,4.5V26.49H768.41a4.5,4.5,0,0,0-4.5,4.5v22.5H752a2.5,2.5,0,0,0,0,5h11.91v22H752a2.5,2.5,0,0,0,0,5h11.91v22H752a2.5,2.5,0,0,0,0,5h11.91v22H752a2.5,2.5,0,0,0,0,5h11.91v22H752a2.5,2.5,0,0,0,0,5h11.91v22H752a2.5,2.5,0,0,0,0,5h11.91v22H752a2.5,2.5,0,0,0,0,5h11.91v22H752a2.5,2.5,0,0,0,0,5h11.91v22H752a2.5,2.5,0,0,0,0,5h11.91v22H752a2.5,2.5,0,0,0,0,5h11.91v22H752a2.5,2.5,0,0,0,0,5h11.91v22H752a2.5,2.5,0,0,0,0,5h11.91v22H752a2.5,2.5,0,0,0,0,5h11.91v22H752a2.5,2.5,0,0,0,0,5h11.91v22H752a2.5,2.5,0,0,0,0,5h11.91v22H752a2.5,2.5,0,0,0,0,5h11.91v22.51a4.51,4.51,0,0,0,4.5,4.5h298a22.52,22.52,0,0,0,22.5-22.5V49A22.52,22.52,0,0,0,1066.43,26.49ZM834.07,16.81h33.84v12.1s0,.05,0,.08,0,0,0,.07V205.9l-14.2-15.36a3.68,3.68,0,0,0-5.44,0l-14.2,15.37ZM794.91,485.16h-26v-22h8.59a2.5,2.5,0,0,0,0-5h-8.59v-22h8.59a2.5,2.5,0,0,0,0-5h-8.59v-22h8.59a2.5,2.5,0,0,0,0-5h-8.59v-22h8.59a2.5,2.5,0,0,0,0-5h-8.59v-22h8.59a2.5,2.5,0,0,0,0-5h-8.59v-22h8.59a2.5,2.5,0,0,0,0-5h-8.59v-22h8.59a2.5,2.5,0,0,0,0-5h-8.59v-22h8.59a2.5,2.5,0,0,0,0-5h-8.59v-22h8.59a2.5,2.5,0,0,0,0-5h-8.59v-22h8.59a2.5,2.5,0,0,0,0-5h-8.59v-22h8.59a2.5,2.5,0,0,0,0-5h-8.59v-22h8.59a2.5,2.5,0,0,0,0-5h-8.59v-22h8.59a2.5,2.5,0,0,0,0-5h-8.59v-22h8.59a2.5,2.5,0,0,0,0-5h-8.59v-22h8.59a2.5,2.5,0,0,0,0-5h-8.59v-22h8.59a2.5,2.5,0,0,0,0-5h-8.59v-22h26Zm9,0h-4V31.49h4Zm280-17.5a17.52,17.52,0,0,1-17.5,17.5H808.92V31.49h20.15V208.21a4.43,4.43,0,0,0,2.65,4.25,3.53,3.53,0,0,0,1.3.25,3.69,3.69,0,0,0,2.71-1.23L851,195l15.26,16.52h0a3.6,3.6,0,0,0,4,1,4.44,4.44,0,0,0,2.64-4.25V31.49h193.52a17.52,17.52,0,0,1,17.5,17.5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M953.44,168.19h103a4.5,4.5,0,0,0,4.5-4.5v-103a4.5,4.5,0,0,0-4.5-4.5h-103a4.51,4.51,0,0,0-4.5,4.5v103A4.51,4.51,0,0,0,953.44,168.19Zm.5-107h102v102h-102Z",
    transform: "translate(-49.36 -8.81)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M941.43,180.2h103a2.5,2.5,0,0,0,0-5H941.93V72.7a2.5,2.5,0,0,0-5,0v103A4.51,4.51,0,0,0,941.43,180.2Z",
    transform: "translate(-49.36 -8.81)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M784.58,633H762.09v-5.66a10.51,10.51,0,0,0-10.5-10.5H696.68l-26.32-54.62a6.48,6.48,0,0,0-8-3.3L498.19,616.79H446.42L437.14,592a4.5,4.5,0,0,0-4.46-4H355.75a4.51,4.51,0,0,0-4.5,4.5v24.23H302.54a10.51,10.51,0,0,0-10.5,10.5v309.4a19,19,0,0,0,19,19H779.69a2.49,2.49,0,0,0,1.83-.8,19.12,19.12,0,0,0,13.56-18.2V643.45A10.51,10.51,0,0,0,784.58,633Zm-22.49,30.52h11.62v256H762.09ZM664,563.58a1.5,1.5,0,0,1,1.85.76l25.27,52.45H513.22ZM311,950.69a14,14,0,0,1-14-14V627.29a5.5,5.5,0,0,1,5.5-5.5h49.21a4.51,4.51,0,0,0,4.5-4.5V593.06h75.94l9.67,25.8a4.52,4.52,0,0,0,4.21,2.93H751.59a5.5,5.5,0,0,1,5.5,5.5v31.18h0v266h0v11.79a19.73,19.73,0,0,0,5.9,14c.15.15.3.3.46.44Zm479-14a14.06,14.06,0,0,1-13.73,14,13.72,13.72,0,0,1-9.86-4,14.67,14.67,0,0,1-4.4-10.42V924.47h12.12a4.51,4.51,0,0,0,4.5-4.5V663a4.51,4.51,0,0,0-4.5-4.5H762.09V638h22.49a5.5,5.5,0,0,1,5.5,5.5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M369.36,612H422a2.5,2.5,0,0,0,0-5H369.36a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M525.06,645H321.69a4.51,4.51,0,0,0-4.5,4.5v39a4.51,4.51,0,0,0,4.5,4.5H525.06a4.51,4.51,0,0,0,4.5-4.5v-39A4.51,4.51,0,0,0,525.06,645Zm-.5,43H322.19V650H524.56Z",
    transform: "translate(-49.36 -8.81)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M331.68,665.46H439.19a2.5,2.5,0,1,0,0-5H331.68a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M331.68,677.47h155a2.5,2.5,0,1,0,0-5h-155a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1139,232.84a2.5,2.5,0,0,0,2.5-2.5V67.83a2.48,2.48,0,0,0-.3-1.17,2.41,2.41,0,0,0,.3-1.16,35,35,0,1,1,70,0,2.42,2.42,0,0,0,.31,1.16,2.49,2.49,0,0,0-.31,1.17V237.51a28.5,28.5,0,0,1-57,0V103a22.09,22.09,0,0,1,44.18,0V236.29a15.89,15.89,0,0,1-31.78,0V106.34a2.5,2.5,0,1,0-5,0v130a20.89,20.89,0,0,0,41.78,0V103a27.09,27.09,0,0,0-54.18,0V237.51a33.5,33.5,0,0,0,67,0V67.83a2.48,2.48,0,0,0-.3-1.17,2.41,2.41,0,0,0,.3-1.16,40,40,0,1,0-80,0,2.53,2.53,0,0,0,.3,1.16,2.6,2.6,0,0,0-.3,1.17V230.34A2.5,2.5,0,0,0,1139,232.84Z",
    transform: "translate(-49.36 -8.81)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.81,766.08c10.73-25.88,14.91-54.89,16.69-67.28.19-1.31.35-2.45.51-3.45a80.29,80.29,0,0,0-2.76-29.92c-4.27-14.3-15-32.18-42.09-36.18a63.94,63.94,0,0,0-50.86,13.94v-18a25.6,25.6,0,0,0,12.44,3.23,27.23,27.23,0,0,0,5-.48c13.87-2.65,27-15.81,38.93-39.11l.63-1.24L205.77,585h-1.39c-26.18-.28-43.95,5.14-52.72,16.17-.5.63-.94,1.26-1.36,1.89V590.56a2.5,2.5,0,0,0-5,0v52.5a64,64,0,0,0-50.72-13.81c-27,4-37.81,21.88-42.08,36.18a80,80,0,0,0-2.75,30c.14.94.31,2.08.49,3.39,1.79,12.39,6,41.4,16.7,67.28C80.55,798.92,100,816,124.75,817c.69,0,1.37,0,2,0a44.48,44.48,0,0,0,21.07-5A45.21,45.21,0,0,0,171,817C195.74,816,215.19,798.92,228.81,766.08ZM166.92,623a20.88,20.88,0,0,1-13.52-1.81l44.54-26.86C188.08,611,177.44,620.91,166.92,623Zm-11.34-18.71c6.64-8.35,20.23-13.16,39.55-14.11L151,616.76A20.64,20.64,0,0,1,155.58,604.26ZM170.81,812a40.19,40.19,0,0,1-21-4.59l-1.92-1.07-1.23.7a39.87,39.87,0,0,1-21.69,5c-35.59-1.32-59.05-39.63-69.74-113.87-.19-1.33-.35-2.48-.49-3.37a76.29,76.29,0,0,1,2.63-28c5.63-18.69,18.41-29.63,38-32.53a62.22,62.22,0,0,1,9.13-.68,59.6,59.6,0,0,1,40.85,16.31v8.47c-9.89-.6-18.86-4.71-23.82-11a2.5,2.5,0,0,0-3.94,3.08c6.3,8,17.89,13.06,30.26,13.06s24-5,30.25-13.06a2.5,2.5,0,1,0-3.94-3.08c-5,6.34-13.92,10.45-23.81,11V650a59.6,59.6,0,0,1,50.13-15.78c19.57,2.9,32.35,13.84,38,32.53a76.41,76.41,0,0,1,2.64,27.94c-.14,1-.31,2.1-.5,3.43C229.86,772.33,206.4,810.64,170.81,812Z",
    transform: "translate(-49.36 -8.81)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M217.1,653.13h0c-7.44-7-17.31-11.62-21.77-6.87s.74,14.31,8.18,21.31a37.14,37.14,0,0,0,11.62,7.69,14.64,14.64,0,0,0,5.2,1.11,6.59,6.59,0,0,0,5-1.92c1.21-1.29,2.85-4.33.19-10.19A37.16,37.16,0,0,0,217.1,653.13ZM221.65,671c-.39.41-2,.64-4.74-.42a32.66,32.66,0,0,1-10-6.67c-7.48-7-9-13.18-8-14.25a1.76,1.76,0,0,1,1.29-.38c2.49,0,7.78,2.17,13.42,7.47h0a32.76,32.76,0,0,1,7.25,9.56C222.16,669,222,670.62,221.65,671Z",
    transform: "translate(-49.36 -8.81)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1141,475.38h3v8h-2.33a4.51,4.51,0,0,0-4.06,6.44l8.1,16.94a4.5,4.5,0,0,0,4.06,2.56h229.46a4.51,4.51,0,0,0,4.06-2.56l8.1-16.94a4.51,4.51,0,0,0-4.06-6.44H1385v-8h3.5a4.51,4.51,0,0,0,4.5-4.5V377.4h.54c.61,0,15,.16,15,13.77a2.5,2.5,0,1,0,5,0c0-9.72-5.54-14.34-10.2-16.5a25.76,25.76,0,0,0-9.8-2.27h-116a2.53,2.53,0,0,0-.87.16A39.3,39.3,0,0,0,1205.78,384l-34.47-10.79a4.49,4.49,0,0,0-5.7,3.16l-28.93,93.36,0,.17a4.51,4.51,0,0,0,4.38,5.53Zm245.51,13-7.62,15.94H1150.07l-7.62-15.94h244.07Zm-6.53-5H1149v-8h231Zm-12.29-106-17.31,23.12a44.27,44.27,0,0,1-44.91,14.65l-24.71-7.74a39.27,39.27,0,0,0-1.4-30Zm-123.92-17.64A34.33,34.33,0,0,1,1276,405.94l-19-6a14.05,14.05,0,0,0,.45-3.5,14.42,14.42,0,0,0-27.9-5.09l-19-5.94A34.39,34.39,0,0,1,1243.78,359.76Zm8.43,38.73-17.89-5.6a9.41,9.41,0,0,1,18.11,3.59A9.59,9.59,0,0,1,1252.21,398.49Zm-81.91-20.41L1304.05,420l.12,0a49.33,49.33,0,0,0,50.12-16.34l19.65-26.26h14v93H1141.7Z",
    transform: "translate(-49.36 -8.81)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1160.82,458.9h46.84a2.5,2.5,0,0,0,0-5h-46.84a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1288.76,324.06h120.69a18.52,18.52,0,0,0,18.5-18.5V120.1a18.52,18.52,0,0,0-18.5-18.5H1384v-15a10.5,10.5,0,0,0-7-9.87V69.34a5.5,5.5,0,0,0-5.5-5.5h-6.18V36.89a16.3,16.3,0,0,0-3.41-9.95l-5.26-6.81a9.55,9.55,0,0,0-7.6-3.72h0a9.55,9.55,0,0,0-7.59,3.72l-5.27,6.81a16.35,16.35,0,0,0-3.4,10v27h-6.18a5.5,5.5,0,0,0-5.5,5.5v7.42a10.5,10.5,0,0,0-7,9.87v15h-25.43a18.52,18.52,0,0,0-18.5,18.5V305.56A18.52,18.52,0,0,0,1288.76,324.06Zm49.08-287.17A11.31,11.31,0,0,1,1340.2,30l5.26-6.8a4.72,4.72,0,0,1,1.14-1.05v20.4a2.5,2.5,0,0,0,5,0V22.15a4.54,4.54,0,0,1,1.14,1.05L1358,30a11.31,11.31,0,0,1,2.36,6.89v26.8h-22.53ZM1423,172.29h-60.08a2.5,2.5,0,0,0,0,5H1423V269.1h-79.07V152.44H1423ZM1326.16,69.34a.5.5,0,0,1,.5-.5h44.89a.5.5,0,0,1,.5.5v6.79h-45.89Zm-7,17.29a5.51,5.51,0,0,1,5.5-5.5h1.09V94.87a2.5,2.5,0,1,0,5,0V81.13h4.77V94.87a2.5,2.5,0,1,0,5,0V81.13h25.22V94.87a2.5,2.5,0,0,0,5,0V81.13h2.75a5.51,5.51,0,0,1,5.5,5.5v15h-59.83Zm-43.93,33.47a13.51,13.51,0,0,1,13.5-13.5h120.69a13.51,13.51,0,0,1,13.5,13.5v27.34h-79.57a4.51,4.51,0,0,0-4.5,4.5V269.6a4.5,4.5,0,0,0,4.5,4.5H1423v31.46a13.51,13.51,0,0,1-13.5,13.5H1288.76a13.51,13.51,0,0,1-13.5-13.5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1362.87,211.07h45.85a2.5,2.5,0,0,0,0-5h-45.85a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1362.87,227.51h45.85a2.5,2.5,0,0,0,0-5h-45.85a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1362.87,244h45.85a2.5,2.5,0,0,0,0-5h-45.85a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1519.86,50a11,11,0,1,0-11,11A11,11,0,0,0,1519.86,50Zm-11,6a6,6,0,1,1,6-6A6,6,0,0,1,1508.87,56Z",
    transform: "translate(-49.36 -8.81)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1468.86,524.28h80a4.51,4.51,0,0,0,4.5-4.5V22.83a4.51,4.51,0,0,0-4.5-4.5h-80a4.51,4.51,0,0,0-4.5,4.5v497A4.51,4.51,0,0,0,1468.86,524.28Zm.5-500.95h79v63h-31a2.5,2.5,0,0,0,0,5h31v15.56H1533a2.5,2.5,0,0,0,0,5h15.37V126H1533a2.5,2.5,0,1,0,0,5h15.37v14.11H1533a2.5,2.5,0,0,0,0,5h15.37v14.11H1533a2.5,2.5,0,0,0,0,5h15.37v15.55h-31a2.5,2.5,0,0,0,0,5h31v15.56H1533a2.5,2.5,0,0,0,0,5h15.37v14.11H1533a2.5,2.5,0,0,0,0,5h15.37v14.1H1533a2.5,2.5,0,0,0,0,5h15.37v14.11H1533a2.5,2.5,0,0,0,0,5h15.37v15.56h-31a2.5,2.5,0,0,0,0,5h31v15.56H1533a2.5,2.5,0,0,0,0,5h15.37v14.1H1533a2.5,2.5,0,0,0,0,5h15.37V342H1533a2.5,2.5,0,0,0,0,5h15.37v14.11H1533a2.5,2.5,0,0,0,0,5h15.37v15.55h-31a2.5,2.5,0,0,0,0,5h31v15.56H1533a2.5,2.5,0,0,0,0,5h15.37v14.11H1533a2.5,2.5,0,0,0,0,5h15.37v14.11H1533a2.5,2.5,0,0,0,0,5h15.37v14.1H1533a2.5,2.5,0,0,0,0,5h15.37V480.1h-31a2.5,2.5,0,0,0,0,5h31v34.18h-79Z",
    transform: "translate(-49.36 -8.81)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M463,1290.26,371.14,1158.4a7.49,7.49,0,0,1-1.34-4.29V1069a15.36,15.36,0,0,0-2.37-30.54H307.34A15.36,15.36,0,0,0,305,1069v85.11a7.5,7.5,0,0,1-1.35,4.29l-91.77,131.75-.14.22a22.5,22.5,0,0,0,19.67,33.43h212a22.5,22.5,0,0,0,19.66-33.43Zm-153-221H364.8v63.88L310,1119Zm-12.68-12.88h42.79a2.5,2.5,0,0,0,0-5H297.29a10.37,10.37,0,0,1,10-7.87h60.09a10.37,10.37,0,1,1,0,20.74H307.34A10.37,10.37,0,0,1,297.29,1056.33Zm161.18,253.84a17.35,17.35,0,0,1-15.08,8.63h-212A17.5,17.5,0,0,1,216,1292.9l91.7-131.64a12.51,12.51,0,0,0,2.24-7.15V1124.2l54.83,14v15.86a12.44,12.44,0,0,0,2.24,7.15l91.7,131.64A17.32,17.32,0,0,1,458.47,1310.17Z",
    transform: "translate(-49.36 -8.81)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M312.17,1182.9a2.5,2.5,0,0,0-3.48.62l-65.49,94a2.5,2.5,0,0,0,.62,3.48,2.45,2.45,0,0,0,1.43.45,2.48,2.48,0,0,0,2.05-1.07l65.49-94A2.5,2.5,0,0,0,312.17,1182.9Z",
    transform: "translate(-49.36 -8.81)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M381.11,1237.81A29.17,29.17,0,1,0,410.28,1267,29.2,29.2,0,0,0,381.11,1237.81Zm0,53.34A24.17,24.17,0,1,1,405.28,1267,24.2,24.2,0,0,1,381.11,1291.15Z",
    transform: "translate(-49.36 -8.81)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M394.94,1266.89a2.5,2.5,0,0,0-2.5,2.5,9.33,9.33,0,0,1-9.32,9.33,2.5,2.5,0,0,0,0,5,14.35,14.35,0,0,0,14.32-14.33A2.5,2.5,0,0,0,394.94,1266.89Z",
    transform: "translate(-49.36 -8.81)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M317.27,1222.14a16.17,16.17,0,1,0,16.17,16.17A16.19,16.19,0,0,0,317.27,1222.14Zm0,27.34a11.17,11.17,0,1,1,11.17-11.17A11.18,11.18,0,0,1,317.27,1249.48Z",
    transform: "translate(-49.36 -8.81)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M381.35,1205.94a21.17,21.17,0,1,0-21.16,21.16A21.18,21.18,0,0,0,381.35,1205.94Zm-37.33,0a16.17,16.17,0,1,1,16.17,16.16A16.18,16.18,0,0,1,344,1205.94Z",
    transform: "translate(-49.36 -8.81)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M352.05,1056.33h16.59a2.5,2.5,0,0,0,0-5H352.05a2.5,2.5,0,1,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1530.34,1228.73a28.9,28.9,0,1,0,28.9,28.9A28.93,28.93,0,0,0,1530.34,1228.73Zm0,52.8a23.9,23.9,0,1,1,23.9-23.9A23.93,23.93,0,0,1,1530.34,1281.53Z",
    transform: "translate(-49.36 -8.81)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1442.34,1228.73a28.9,28.9,0,1,0,28.9,28.9A28.94,28.94,0,0,0,1442.34,1228.73Zm0,52.8a23.9,23.9,0,1,1,23.9-23.9A23.93,23.93,0,0,1,1442.34,1281.53Z",
    transform: "translate(-49.36 -8.81)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1530.34,1211.13a45.92,45.92,0,0,0-16.5,3V1021.31a27.5,27.5,0,1,0-55,0v192.84a46.5,46.5,0,1,0,27.5,58.54,46.5,46.5,0,1,0,44-61.56Zm-21.5-189.82v118.33h-20V999A22.54,22.54,0,0,1,1508.84,1021.31Zm-25-22.36v140.69h-20V1021.31A22.54,22.54,0,0,1,1483.84,999Zm-41.5,300.18a41.5,41.5,0,1,1,17.92-78.94l3.58,1.72v-77.27h20v12.19a17.31,17.31,0,0,0,0,34.27v63.18h-.06l0,2.94c0,.14,0,.27,0,.41A41.54,41.54,0,0,1,1442.34,1299.13Zm44-112.83a12.34,12.34,0,1,1,12.33-12.34A12.34,12.34,0,0,1,1486.34,1186.3Zm44,112.83a41.54,41.54,0,0,1-41.5-41.5c0-.14,0-.29,0-.44l0-2.91h0V1191.1a17.31,17.31,0,0,0,0-34.27v-12.19h20v77.27l3.58-1.72a41.5,41.5,0,1,1,17.92,78.94Z",
    transform: "translate(-49.36 -8.81)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1488.2,1167.86l-8.5,8.5a2.49,2.49,0,0,0,0,3.53,2.45,2.45,0,0,0,1.76.73,2.49,2.49,0,0,0,1.77-.73l8.5-8.5a2.5,2.5,0,1,0-3.53-3.53Z",
    transform: "translate(-49.36 -8.81)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1418,604.22V876.69a4.87,4.87,0,0,0,4.86,4.86h63.28a4.87,4.87,0,0,0,4.86-4.86V604.22a21.42,21.42,0,0,0-21.39-21.39h-30.22A21.41,21.41,0,0,0,1418,604.22Zm33.09,248.93h21V876a2.6,2.6,0,0,0,.07.56h-21.13a2.1,2.1,0,0,0,.07-.56Zm-28.09-5v-5.63h63v5.63Zm51.58-124.44a2.49,2.49,0,0,0,2.5-2.5V653.48H1486V826.89h-63V653.48h49.08v67.73A2.5,2.5,0,0,0,1474.61,723.71ZM1486,831.89v5.63h-63v-5.63Zm0-183.41h-63v-6h63Zm-63,204.67h23.09V876a2.6,2.6,0,0,0,.07.56H1423Zm54,23.4a2.6,2.6,0,0,0,.06-.56V853.15H1486v23.4Zm-37.63-288.72h30.22A16.41,16.41,0,0,1,1486,604.22v33.23h-63V604.22A16.41,16.41,0,0,1,1439.42,587.83Z",
    transform: "translate(-49.36 -8.81)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M251.27,1126.27V928.63a20.46,20.46,0,0,0-8.45-16.55,4,4,0,0,0,1.25-2.3l7.12-41.59a5.69,5.69,0,0,0-5.61-6.64h-7.14v-10.1a6.51,6.51,0,0,0-6.5-6.5H213.1a6.51,6.51,0,0,0-6.5,6.5v10.1h-7.14a5.69,5.69,0,0,0-5.61,6.64L201,909.78a4,4,0,0,0,1.26,2.3,20.45,20.45,0,0,0-8.46,16.55v197.64a3.5,3.5,0,0,0,3.5,3.5h50.5A3.5,3.5,0,0,0,251.27,1126.27ZM211.6,851.45a1.5,1.5,0,0,1,1.5-1.5h18.84a1.5,1.5,0,0,1,1.5,1.5v10.1H211.6Zm-12.67,15.34a.69.69,0,0,1,.53-.24h46.12a.68.68,0,0,1,.68.8l-4.7,27.46H203.48l-4.7-27.46A.74.74,0,0,1,198.93,866.79Zm6.84,41.39-1.44-8.37h36.38l-1.43,8.37h-7.59c-.3,0-.61,0-.92,0h-16.5c-.31,0-.61,0-.92,0Zm-7,51.61h18.82v118.33H198.77Zm47.5,165h-47.5v-41.65h23.82V954.79H198.77V928.63a15.51,15.51,0,0,1,14.58-15.45h18.34a15.51,15.51,0,0,1,14.58,15.45Z",
    transform: "translate(-49.36 -8.81)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.94,970.36a2.5,2.5,0,0,0-2.5,2.5v91.61a2.5,2.5,0,0,0,5,0V972.86A2.5,2.5,0,0,0,235.94,970.36Z",
    transform: "translate(-49.36 -8.81)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.94,927.33a2.5,2.5,0,0,0-2.5,2.5V959.2a2.5,2.5,0,0,0,5,0V929.83A2.5,2.5,0,0,0,235.94,927.33Z",
    transform: "translate(-49.36 -8.81)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1030.29,99.24h-14.1l-4.36-13.41a7.24,7.24,0,0,0-13.78,0l-4.36,13.41h-14.1a7.25,7.25,0,0,0-4.26,13.11l11.41,8.29-4.36,13.41a7.13,7.13,0,0,0,2.63,8.1,7.14,7.14,0,0,0,8.52,0l11.41-8.29,11.4,8.29a7.25,7.25,0,0,0,11.16-8.1l-4.36-13.41,11.41-8.29a7.25,7.25,0,0,0-4.26-13.11Zm1.32,9.07-11.48,8.34a4.84,4.84,0,0,0-1.77,5.45l4.38,13.49a2.25,2.25,0,0,1-3.46,2.52l-11.48-8.34a4.84,4.84,0,0,0-5.73,0l-11.48,8.34a2.25,2.25,0,0,1-3.46-2.52l4.39-13.49a4.87,4.87,0,0,0-1.77-5.45l-11.48-8.34a2.25,2.25,0,0,1,1.32-4.07h14.19a4.87,4.87,0,0,0,4.64-3.37l4.38-13.49a2.25,2.25,0,0,1,4.28,0l4.38,13.49a4.87,4.87,0,0,0,4.64,3.37h14.19a2.25,2.25,0,0,1,1.32,4.07Z",
    transform: "translate(-49.36 -8.81)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1050.39,552.65h-194a18.52,18.52,0,0,0-18.5,18.5V889.49a18.52,18.52,0,0,0,18.5,18.5h194a18.52,18.52,0,0,0,18.5-18.5V571.15A18.52,18.52,0,0,0,1050.39,552.65Zm-207.5,104.2h221V883.49a5.51,5.51,0,0,1-5.5,5.5h-210a5.5,5.5,0,0,1-5.5-5.5Zm221-5h-221v-56h221ZM1050.39,903h-194a13.51,13.51,0,0,1-13.11-10.34,10.38,10.38,0,0,0,5.11,1.34h210a10.44,10.44,0,0,0,5.11-1.34A13.52,13.52,0,0,1,1050.39,903Zm13.5-312.18h-221V571.15a13.51,13.51,0,0,1,13.5-13.5h194a13.52,13.52,0,0,1,13.5,13.5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1008.38,861.84h30a4.51,4.51,0,0,0,4.5-4.5V780.17a4.51,4.51,0,0,0-4.5-4.5h-30a4.51,4.51,0,0,0-4.5,4.5v77.17A4.51,4.51,0,0,0,1008.38,861.84Zm.5-5v-4.11h29v4.11Zm29-76.17v67.06h-29V780.67Z",
    transform: "translate(-49.36 -8.81)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M866.39,640.14h34a2.5,2.5,0,0,0,0-5h-34a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M868.39,720.34h30a4.51,4.51,0,0,0,4.5-4.5v-30a4.51,4.51,0,0,0-4.5-4.5h-30a4.51,4.51,0,0,0-4.5,4.5v30A4.51,4.51,0,0,0,868.39,720.34Zm.5-5v-4.73h29v4.73Zm29-29v19.27h-29V686.34Z",
    transform: "translate(-49.36 -8.81)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M915.05,720.34h30a4.5,4.5,0,0,0,4.5-4.5v-30a4.5,4.5,0,0,0-4.5-4.5h-30a4.51,4.51,0,0,0-4.5,4.5v30A4.51,4.51,0,0,0,915.05,720.34Zm.5-5v-4.73h29v4.73Zm29-29v19.27h-29V686.34Z",
    transform: "translate(-49.36 -8.81)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M961.72,720.34h30a4.51,4.51,0,0,0,4.5-4.5v-30a4.51,4.51,0,0,0-4.5-4.5h-30a4.51,4.51,0,0,0-4.5,4.5v30A4.51,4.51,0,0,0,961.72,720.34Zm.5-5v-4.73h29v4.73Zm29-29v19.27h-29V686.34Z",
    transform: "translate(-49.36 -8.81)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1008.38,720.34h30a4.51,4.51,0,0,0,4.5-4.5v-30a4.51,4.51,0,0,0-4.5-4.5h-30a4.51,4.51,0,0,0-4.5,4.5v30A4.51,4.51,0,0,0,1008.38,720.34Zm.5-5v-4.73h29v4.73Zm29-29v19.27h-29V686.34Z",
    transform: "translate(-49.36 -8.81)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M868.39,815.08h30a4.51,4.51,0,0,0,4.5-4.5v-30a4.51,4.51,0,0,0-4.5-4.5h-30a4.51,4.51,0,0,0-4.5,4.5v30A4.51,4.51,0,0,0,868.39,815.08Zm.5-5v-4.73h29v4.73Zm29-29v19.27h-29V781.08Z",
    transform: "translate(-49.36 -8.81)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M915.05,815.08h30a4.5,4.5,0,0,0,4.5-4.5v-30a4.5,4.5,0,0,0-4.5-4.5h-30a4.51,4.51,0,0,0-4.5,4.5v30A4.51,4.51,0,0,0,915.05,815.08Zm.5-5v-4.73h29v4.73Zm29-29v19.27h-29V781.08Z",
    transform: "translate(-49.36 -8.81)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M961.72,815.08h30a4.51,4.51,0,0,0,4.5-4.5v-30a4.51,4.51,0,0,0-4.5-4.5h-30a4.51,4.51,0,0,0-4.5,4.5v30A4.51,4.51,0,0,0,961.72,815.08Zm.5-5v-4.73h29v4.73Zm29-29v19.27h-29V781.08Z",
    transform: "translate(-49.36 -8.81)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M868.39,862.45h30a4.51,4.51,0,0,0,4.5-4.5V828a4.51,4.51,0,0,0-4.5-4.5h-30a4.51,4.51,0,0,0-4.5,4.5v30A4.51,4.51,0,0,0,868.39,862.45Zm.5-5v-4.72h29v4.72Zm29-29v19.28h-29V828.45Z",
    transform: "translate(-49.36 -8.81)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M915.05,862.45h30a4.5,4.5,0,0,0,4.5-4.5V828a4.5,4.5,0,0,0-4.5-4.5h-30a4.51,4.51,0,0,0-4.5,4.5v30A4.51,4.51,0,0,0,915.05,862.45Zm.5-5v-4.72h29v4.72Zm29-29v19.28h-29V828.45Z",
    transform: "translate(-49.36 -8.81)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M961.72,862.45h30a4.51,4.51,0,0,0,4.5-4.5V828a4.51,4.51,0,0,0-4.5-4.5h-30a4.51,4.51,0,0,0-4.5,4.5v30A4.51,4.51,0,0,0,961.72,862.45Zm.5-5v-4.72h29v4.72Zm29-29v19.28h-29V828.45Z",
    transform: "translate(-49.36 -8.81)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M868.39,767.71h30a4.51,4.51,0,0,0,4.5-4.5v-30a4.51,4.51,0,0,0-4.5-4.5h-30a4.51,4.51,0,0,0-4.5,4.5v30A4.51,4.51,0,0,0,868.39,767.71Zm.5-5V758h29v4.73Zm29-29V753h-29V733.71Z",
    transform: "translate(-49.36 -8.81)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M915.05,767.71h30a4.5,4.5,0,0,0,4.5-4.5v-30a4.5,4.5,0,0,0-4.5-4.5h-30a4.51,4.51,0,0,0-4.5,4.5v30A4.51,4.51,0,0,0,915.05,767.71Zm.5-5V758h29v4.73Zm29-29V753h-29V733.71Z",
    transform: "translate(-49.36 -8.81)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M961.72,767.71h30a4.51,4.51,0,0,0,4.5-4.5v-30a4.51,4.51,0,0,0-4.5-4.5h-30a4.51,4.51,0,0,0-4.5,4.5v30A4.51,4.51,0,0,0,961.72,767.71Zm.5-5V758h29v4.73Zm29-29V753h-29V733.71Z",
    transform: "translate(-49.36 -8.81)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1008.38,767.71h30a4.51,4.51,0,0,0,4.5-4.5v-30a4.51,4.51,0,0,0-4.5-4.5h-30a4.51,4.51,0,0,0-4.5,4.5v30A4.51,4.51,0,0,0,1008.38,767.71Zm.5-5V758h29v4.73Zm29-29V753h-29V733.71Z",
    transform: "translate(-49.36 -8.81)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.31,883.92h-8.13V857.79H65.59v216.07h9.22v252.4H117v-252.4h9.22V934.34a8.71,8.71,0,0,1,6,8.26v99a8,8,0,1,0,16,0V897.82A13.92,13.92,0,0,0,134.31,883.92Zm0,5a8.91,8.91,0,0,1,8.9,8.9v1.67h-17V888.92Zm-63.72-1v-9H121v9Zm0-25.13h50.59V874H70.59ZM112,1307.26H79.81V1084H112Zm-32.15,14v-9H112v9ZM112,1079H79.81v-5.14H112Zm5-10.14H70.59V892.92h8.59v160.53a2.5,2.5,0,0,0,5,0V892.92H121v41h.16v134.94Zm23.24-24.26a3,3,0,0,1-3-3V914.92a2.5,2.5,0,0,0-5,0V932a13.77,13.77,0,0,0-6-2.85v-24.7h17v137.1A3,3,0,0,1,140.2,1044.6Z",
    transform: "translate(-49.36 -8.81)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1245.57,1004.38h-17.83V983.87a8.51,8.51,0,0,0-8.5-8.5h-150a43.08,43.08,0,0,0-40.91,29.77,43.06,43.06,0,0,0-40.91-29.77h-150a8.51,8.51,0,0,0-8.5,8.5v20.51H811.18a12.51,12.51,0,0,0-12.5,12.5v272.79c0,.1,0,.19,0,.29s0,.09,0,.14v12.58a12.52,12.52,0,0,0,12.5,12.5h434.39a12.52,12.52,0,0,0,12.5-12.5V1290.1s0-.09,0-.14,0-.19,0-.29V1016.88A12.51,12.51,0,0,0,1245.57,1004.38ZM1222.74,1248H1069.06a2.5,2.5,0,0,0,0,5h153.68v10.76a3.5,3.5,0,0,1-3.5,3.5H1031.37a38,38,0,0,1,37.91-35.5l153.46,0ZM834,1252.87a2.49,2.49,0,0,0,.87.17h154a2.5,2.5,0,1,0,0-5h-154a2.49,2.49,0,0,0-.87.16v-16.43l153.45,0a38,38,0,0,1,37.91,35.5H837.51a3.5,3.5,0,0,1-3.5-3.5Zm197.27-234.5a38,38,0,0,1,38-38h150a3.5,3.5,0,0,1,3.5,3.5v242.9H1069.28l-2.5,0v.07a43.08,43.08,0,0,0-35.5,22.82ZM834,983.87a3.5,3.5,0,0,1,3.5-3.5h150a38,38,0,0,1,38,38v231.32A43.08,43.08,0,0,0,990,1226.87v-.1H834Zm-30.33,33a7.5,7.5,0,0,1,7.5-7.5H829V1263.8a8.51,8.51,0,0,0,8.5,8.5h381.73a8.51,8.51,0,0,0,8.5-8.5V1009.38h17.83a7.51,7.51,0,0,1,7.5,7.5v272.79a7.52,7.52,0,0,1-7.5,7.5H811.18a7.51,7.51,0,0,1-7.5-7.5Zm441.89,293.3H811.18a7.51,7.51,0,0,1-7.5-7.5v-3a12.39,12.39,0,0,0,7.5,2.53h434.39a12.43,12.43,0,0,0,7.5-2.53v3A7.52,7.52,0,0,1,1245.57,1310.18Z",
    transform: "translate(-49.36 -8.81)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1068.06,1188.41h118.15a6.5,6.5,0,0,0,6.5-6.5v-93.83a6.5,6.5,0,0,0-6.5-6.5H1068.06a6.51,6.51,0,0,0-6.5,6.5v93.83A6.51,6.51,0,0,0,1068.06,1188.41Zm-1.5-100.33a1.5,1.5,0,0,1,1.5-1.5h118.15a1.5,1.5,0,0,1,1.5,1.5v93.83a1.5,1.5,0,0,1-1.5,1.5H1068.06a1.5,1.5,0,0,1-1.5-1.5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1064.06,1061.51h126.15a2.5,2.5,0,0,0,0-5H1064.06a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1064.06,1203.62h18.16a2.5,2.5,0,1,0,0-5h-18.16a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1145.25,1198.62h-44.16a2.5,2.5,0,0,0,0,5h44.16a2.5,2.5,0,0,0,0-5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1064.06,1045.49h105.22a2.5,2.5,0,0,0,0-5H1064.06a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1064.06,1029.48h126.15a2.5,2.5,0,0,0,0-5H1064.06a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1064.06,1013.47h76.11a2.5,2.5,0,0,0,0-5h-76.11a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M863.9,1126.56H990.05a2.5,2.5,0,0,0,0-5H863.9a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M863.9,1110.55H969.12a2.5,2.5,0,1,0,0-5H863.9a2.5,2.5,0,1,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M863.9,1094.53H990.05a2.5,2.5,0,0,0,0-5H863.9a2.5,2.5,0,1,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M863.9,1078.52H940a2.5,2.5,0,0,0,0-5H863.9a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M992.55,1188.11a2.5,2.5,0,0,0-2.5-2.5H863.9a2.5,2.5,0,1,0,0,5H990.05A2.5,2.5,0,0,0,992.55,1188.11Z",
    transform: "translate(-49.36 -8.81)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M863.9,1174.6H969.12a2.5,2.5,0,0,0,0-5H863.9a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M863.9,1158.58H990.05a2.5,2.5,0,1,0,0-5H863.9a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M863.9,1142.57H980.05a2.5,2.5,0,0,0,0-5H863.9a2.5,2.5,0,1,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M867.9,1045.49H990.3a6.51,6.51,0,0,0,6.5-6.5v-17.44a6.51,6.51,0,0,0-6.5-6.5H867.9a6.51,6.51,0,0,0-6.5,6.5V1039A6.51,6.51,0,0,0,867.9,1045.49Zm-1.5-23.94a1.5,1.5,0,0,1,1.5-1.5H990.3a1.5,1.5,0,0,1,1.5,1.5V1039a1.5,1.5,0,0,1-1.5,1.5H867.9a1.5,1.5,0,0,1-1.5-1.5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M727.33,1142.13a4.51,4.51,0,0,0,4.5-4.5v-52a4.51,4.51,0,0,0-4.5-4.5H481.89a4.51,4.51,0,0,0-4.5,4.5v8.74l-29.74,3.38a6.49,6.49,0,0,0-5.77,6.45v14.85a6.5,6.5,0,0,0,5.77,6.46l29.74,3.37v8.75a4.51,4.51,0,0,0,4.5,4.5Zm-250.14-18.3-29-3.29a1.49,1.49,0,0,1-1.33-1.49V1104.2a1.5,1.5,0,0,1,1.33-1.49l29-3.28Zm53.86-37.7h6v51h-6Zm-5,51H499v-51h27Zm152.12,0h-6v-51h6Zm5-51h27v51h-27Zm-16,51H542.06v-51h125.1Zm59.67,0H715.19v-51h11.64Zm-244.44-51H494v51H482.39Z",
    transform: "translate(-49.36 -8.81)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M604.61,1129.13c21.82,0,45-6.13,45-17.5s-23.2-17.5-45-17.5-45,6.13-45,17.5S582.79,1129.13,604.61,1129.13Zm0-30c24.79,0,40,7.28,40,12.5s-15.23,12.5-40,12.5-40-7.28-40-12.5S579.81,1099.13,604.61,1099.13Z",
    transform: "translate(-49.36 -8.81)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M691.82,1000.06H446.38a4.51,4.51,0,0,0-4.5,4.5v52a4.5,4.5,0,0,0,4.5,4.5H691.82a4.5,4.5,0,0,0,4.5-4.5v-8.74l29.74-3.37a6.5,6.5,0,0,0,5.77-6.46v-14.85a6.5,6.5,0,0,0-5.77-6.46l-29.74-3.37v-8.75A4.51,4.51,0,0,0,691.82,1000.06Zm4.69,18.3,29,3.29a1.51,1.51,0,0,1,1.33,1.49V1038a1.51,1.51,0,0,1-1.33,1.49l-29,3.29Zm-201-13.3h6v51h-6Zm-5,51h-27v-51h27Zm16-51h125.1v51H506.55Zm130.1,0h6v51h-6Zm11,0h27v51h-27Zm-200.78,0h11.63v51H446.88Zm244.44,51H679.68v-51h11.64Z",
    transform: "translate(-49.36 -8.81)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M569.1,1013.06c-21.82,0-45,6.14-45,17.5s23.2,17.5,45,17.5,45-6.13,45-17.5S590.92,1013.06,569.1,1013.06Zm0,30c-24.8,0-40-7.28-40-12.5s15.22-12.5,40-12.5,40,7.28,40,12.5S593.89,1043.06,569.1,1043.06Z",
    transform: "translate(-49.36 -8.81)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1403.51,1138.55V942.11a8.51,8.51,0,0,0-8.5-8.5h-79.44a8.51,8.51,0,0,0-8.5,8.5v196.44a8.51,8.51,0,0,0,8.5,8.5H1395A8.51,8.51,0,0,0,1403.51,1138.55Zm-91.44,0V942.11a3.5,3.5,0,0,1,3.5-3.5h6.18v203.44h-6.18A3.5,3.5,0,0,1,1312.07,1138.55Zm86.44,0a3.5,3.5,0,0,1-3.5,3.5h-68.26V938.61H1395a3.5,3.5,0,0,1,3.5,3.5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1135.41,888.08h190.83a32.54,32.54,0,0,0,32.5-32.5V606a32.54,32.54,0,0,0-32.5-32.5H1135.41a10.51,10.51,0,0,0-10.5,10.5V877.58A10.51,10.51,0,0,0,1135.41,888.08ZM1156,578.67h8.5V882.86H1156ZM1353.74,606V855.58a27.53,27.53,0,0,1-27.5,27.5H1169.49V578.45h156.75A27.53,27.53,0,0,1,1353.74,606Zm-223.83-22a5.5,5.5,0,0,1,5.5-5.5H1151V883.08h-15.58a5.5,5.5,0,0,1-5.5-5.5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M628.05,1185.5a117.45,117.45,0,0,0-117.32,117.32v2.5H745.37v-2.5A117.45,117.45,0,0,0,628.05,1185.5Zm-112.3,114.82a112.47,112.47,0,0,1,109.8-109.79v31.18a81.24,81.24,0,0,0-78.61,78.61Zm109.8-73.61v73.61H551.91A76.26,76.26,0,0,1,625.55,1226.71Zm5,73.61v-73.61a76.26,76.26,0,0,1,73.63,73.61Zm78.61,0a81.26,81.26,0,0,0-78.61-78.61v-31.18a112.46,112.46,0,0,1,109.79,109.79Z",
    transform: "translate(-49.36 -8.81)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1579.21,758.63a16.24,16.24,0,0,0,0-22.93h0a16.21,16.21,0,1,0,0,22.93Zm-3.53-3.54a11.2,11.2,0,0,1-13.88,1.56l15.44-15.44A11.23,11.23,0,0,1,1575.68,755.09Zm-15.85-15.85a11.2,11.2,0,0,1,13.88-1.56l-15.45,15.44a11.18,11.18,0,0,1,1.57-13.88Z",
    transform: "translate(-49.36 -8.81)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1615.37,1008.22a14.26,14.26,0,0,0-11.73-14V978.38h-14.89v-168a6.51,6.51,0,0,0-6.5-6.5h-2.68V781.06a35.91,35.91,0,0,0,4.84-65.69V670.23h-7V646.84a9.64,9.64,0,0,0-19.28,0v23.39h-7v45.14a35.91,35.91,0,0,0,4.47,65.56v23h-2.31a6.51,6.51,0,0,0-6.5,6.5v205.64a6.5,6.5,0,0,0,1,3.4l10.35,16.93a6.45,6.45,0,0,0,5.51,3.12,6.57,6.57,0,0,0,1.8-.25h0v63.81a6.46,6.46,0,0,0,4.74,6.26,7,7,0,0,0,1.8.25,6.43,6.43,0,0,0,5.51-3.12l10.35-16.94a6.44,6.44,0,0,0,1-3.39v-48.08h14.89v-15.84A14.25,14.25,0,0,0,1615.37,1008.22Zm-16.73,8.87a9.22,9.22,0,0,1,0-17.75Zm-14.89-206.66v168h-13.36v-168a1.5,1.5,0,0,1,1.5-1.5h10.36A1.5,1.5,0,0,1,1583.75,810.43Zm-20.64-163.59a4.64,4.64,0,0,1,9.28,0v23.39h-9.28Zm-7,28.39h23.32v38a36.19,36.19,0,0,0-23.32,0Zm-19.23,71.93a30.88,30.88,0,1,1,9.05,21.85A30.71,30.71,0,0,1,1536.86,747.16ZM1565.11,1033a1.5,1.5,0,0,1-2.78.79L1552,1016.86a1.57,1.57,0,0,1-.22-.79V810.43a1.5,1.5,0,0,1,1.5-1.5h10.36a1.5,1.5,0,0,1,1.5,1.5Zm-1.5-229.08h-3v-21.6a36.18,36.18,0,0,0,14,.07v21.53h-2.68a6.46,6.46,0,0,1-8.28,0Zm20.14,282.2a1.5,1.5,0,0,1-.22.78l-10.36,16.94a1.4,1.4,0,0,1-1.68.66,1.43,1.43,0,0,1-1.1-1.44v-65h13.36Zm-13.36-53.08V983.38h28.25v10.84a14.21,14.21,0,0,0,0,28v10.84Zm33.25-16V999.34a9.22,9.22,0,0,1,0,17.75Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1838.69,
    y: 307.92,
    width: 303.5,
    height: 26.02
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1838.69,
    y: 338.95,
    width: 303.5,
    height: 26.02
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1838.69,
    y: 276.9,
    width: 303.5,
    height: 26.02
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1838.69,
    y: 369.97,
    width: 303.5,
    height: 26.02
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2084.22 13.05 2084.22 67.49 2138.66 67.49 2084.22 13.05"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1838.69,
    y: 432.02,
    width: 303.5,
    height: 26.02
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1838.69,
    y: 401,
    width: 303.5,
    height: 26.02
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1838.69,
    y: 121.77,
    width: 303.5,
    height: 26.02
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1838.69,
    y: 90.75,
    width: 303.5,
    height: 26.02
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2255.48 60.05 2252.19 60.05 2196.19 60.05 2192.9 60.05 2192.9 83.48 2255.48 83.48 2255.48 60.05"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1838.69,
    y: 214.85,
    width: 303.5,
    height: 26.02
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1838.69,
    y: 463.05,
    width: 303.5,
    height: 26.02
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1838.69,
    y: 152.8,
    width: 303.5,
    height: 26.02
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1850.05,691.66a76.41,76.41,0,0,0-2.64-27.94c-5.63-18.69-18.41-29.63-38-32.53A59.6,59.6,0,0,0,1759.3,647v8.32c9.89-.6,18.86-4.71,23.81-11a2.5,2.5,0,0,1,3.94,3.08c-6.29,8-17.89,13.06-30.25,13.06s-24-5-30.26-13.06a2.5,2.5,0,1,1,3.94-3.08c5,6.34,13.93,10.45,23.82,11v-8.47a59.6,59.6,0,0,0-40.85-16.31,62.22,62.22,0,0,0-9.13.68c-19.58,2.9-32.36,13.84-38,32.53a76.29,76.29,0,0,0-2.63,28c.14.89.3,2,.49,3.37,10.69,74.24,34.15,112.55,69.74,113.87a39.87,39.87,0,0,0,21.69-5l1.23-.7,1.92,1.07a40.19,40.19,0,0,0,21,4.59c35.59-1.32,59-39.63,69.74-113.87C1849.74,693.76,1849.91,692.61,1850.05,691.66Zm-15.76-20.21a6.59,6.59,0,0,1-5,1.92,14.73,14.73,0,0,1-5.21-1.11,37.22,37.22,0,0,1-11.61-7.69c-7.44-7-12.64-16.57-8.18-21.31s14.33-.13,21.77,6.87h0a37.16,37.16,0,0,1,8.38,11.13C1837.14,667.12,1835.5,670.16,1834.29,671.45Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1838.69,
    y: 245.87,
    width: 303.5,
    height: 26.02
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2428.53,
    y: 816.64,
    width: 29,
    height: 19.27
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2457.39,886h210a5.51,5.51,0,0,0,5.5-5.5V653.85h-221V880.49A5.5,5.5,0,0,0,2457.39,886Zm155.49-203.15a4.51,4.51,0,0,1,4.5-4.5h30a4.51,4.51,0,0,1,4.5,4.5v30a4.51,4.51,0,0,1-4.5,4.5h-30a4.51,4.51,0,0,1-4.5-4.5Zm0,47.37a4.51,4.51,0,0,1,4.5-4.5h30a4.51,4.51,0,0,1,4.5,4.5v30a4.51,4.51,0,0,1-4.5,4.5h-30a4.51,4.51,0,0,1-4.5-4.5Zm0,47a4.51,4.51,0,0,1,4.5-4.5h30a4.51,4.51,0,0,1,4.5,4.5v77.17a4.51,4.51,0,0,1-4.5,4.5h-30a4.51,4.51,0,0,1-4.5-4.5Zm-46.66-94.33a4.51,4.51,0,0,1,4.5-4.5h30a4.51,4.51,0,0,1,4.5,4.5v30a4.51,4.51,0,0,1-4.5,4.5h-30a4.51,4.51,0,0,1-4.5-4.5Zm0,47.37a4.51,4.51,0,0,1,4.5-4.5h30a4.51,4.51,0,0,1,4.5,4.5v30a4.51,4.51,0,0,1-4.5,4.5h-30a4.51,4.51,0,0,1-4.5-4.5Zm0,47.37a4.51,4.51,0,0,1,4.5-4.5h30a4.51,4.51,0,0,1,4.5,4.5v30a4.51,4.51,0,0,1-4.5,4.5h-30a4.51,4.51,0,0,1-4.5-4.5Zm0,47.37a4.51,4.51,0,0,1,4.5-4.5h30a4.51,4.51,0,0,1,4.5,4.5v30a4.51,4.51,0,0,1-4.5,4.5h-30a4.51,4.51,0,0,1-4.5-4.5Zm-46.67-142.11a4.51,4.51,0,0,1,4.5-4.5h30a4.5,4.5,0,0,1,4.5,4.5v30a4.5,4.5,0,0,1-4.5,4.5h-30a4.51,4.51,0,0,1-4.5-4.5Zm0,47.37a4.51,4.51,0,0,1,4.5-4.5h30a4.5,4.5,0,0,1,4.5,4.5v30a4.5,4.5,0,0,1-4.5,4.5h-30a4.51,4.51,0,0,1-4.5-4.5Zm0,47.37a4.51,4.51,0,0,1,4.5-4.5h30a4.5,4.5,0,0,1,4.5,4.5v30a4.5,4.5,0,0,1-4.5,4.5h-30a4.51,4.51,0,0,1-4.5-4.5Zm0,47.37a4.51,4.51,0,0,1,4.5-4.5h30a4.5,4.5,0,0,1,4.5,4.5v30a4.5,4.5,0,0,1-4.5,4.5h-30a4.51,4.51,0,0,1-4.5-4.5Zm-46.66-142.11a4.51,4.51,0,0,1,4.5-4.5h30a4.51,4.51,0,0,1,4.5,4.5v30a4.51,4.51,0,0,1-4.5,4.5h-30a4.51,4.51,0,0,1-4.5-4.5Zm0,47.37a4.51,4.51,0,0,1,4.5-4.5h30a4.51,4.51,0,0,1,4.5,4.5v30a4.51,4.51,0,0,1-4.5,4.5h-30a4.51,4.51,0,0,1-4.5-4.5Zm0,47.37a4.51,4.51,0,0,1,4.5-4.5h30a4.51,4.51,0,0,1,4.5,4.5v30a4.51,4.51,0,0,1-4.5,4.5h-30a4.51,4.51,0,0,1-4.5-4.5Zm0,47.37a4.51,4.51,0,0,1,4.5-4.5h30a4.51,4.51,0,0,1,4.5,4.5v30a4.51,4.51,0,0,1-4.5,4.5h-30a4.51,4.51,0,0,1-4.5-4.5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2451.89,648.85h221v-56h-221Zm23.5-16.71h34a2.5,2.5,0,0,1,0,5h-34a2.5,2.5,0,0,1,0-5Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2428.53,
    y: 840.92,
    width: 29,
    height: 4.73
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2296.55,30.74a5.51,5.51,0,0,0-5.5-5.5h-35a5.51,5.51,0,0,0-5.5,5.5V63.85h46ZM2261.29,53a2.5,2.5,0,0,1-5,0V36.48a2.5,2.5,0,0,1,5,0Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2428.53,
    y: 769.27,
    width: 29,
    height: 19.27
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2667.39,891h-210a10.38,10.38,0,0,1-5.11-1.34A13.51,13.51,0,0,0,2465.39,900h194a13.52,13.52,0,0,0,13.11-10.34A10.44,10.44,0,0,1,2667.39,891Z",
    transform: "translate(-49.36 -8.81)"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2213.68 420.5 2224.19 428.59 2234.7 420.5 2234.7 88.58 2213.68 88.58 2213.68 420.5"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2219.41 477.2 2224.19 488.99 2228.97 477.2 2219.41 477.2"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2201.19 426.54 2208.68 420.54 2208.68 88.58 2201.19 88.58 2201.19 426.54"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2239.7 420.54 2247.19 426.54 2247.19 88.58 2239.7 88.58 2239.7 420.54"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2659.39,554.65h-194a13.51,13.51,0,0,0-13.5,13.5v19.66h221V568.15A13.52,13.52,0,0,0,2659.39,554.65Z",
    transform: "translate(-49.36 -8.81)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2286.57,433.75h-.07l-12.95,10-12.94-10h-.07l-9.78,7.83,16,39.43h13.61l16-39.43Z",
    transform: "translate(-49.36 -8.81)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1742.06,219.29V58.69a31.36,31.36,0,1,0-62.71,0v160.6ZM1696,70.89a14.71,14.71,0,0,1,29.41,0v96.4a4.51,4.51,0,0,1-4.5,4.5h-.41v17.6a9.8,9.8,0,1,1-19.6,0v-17.6h-.4a4.5,4.5,0,0,1-4.5-4.5Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1630.23,
    y: 850.99,
    width: 50.58,
    height: 11.17
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1680.66 872.11 1680.66 867.15 1630.23 867.15 1630.23 876.11 1680.66 876.11 1680.66 872.11"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1720.41,70.89a9.71,9.71,0,0,0-19.41,0v95.9h19.41Zm-7.21,84.81a2.5,2.5,0,1,1-5,0V75.09a2.5,2.5,0,1,1,5,0Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1639.44,
    y: 1300.45,
    width: 32.16,
    height: 9
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2428.53,
    y: 793.55,
    width: 29,
    height: 4.73
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1752.21,896.49v-1.67a8.91,8.91,0,0,0-8.9-8.9h-8.13v10.57Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1639.44,
    y: 1072.19,
    width: 32.16,
    height: 223.26
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1639.44,
    y: 1062.05,
    width: 32.16,
    height: 5.14
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1762.4,618.16a20.88,20.88,0,0,0,13.52,1.81c10.52-2.06,21.16-11.93,31-28.67Z",
    transform: "translate(-49.36 -8.81)"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1838.69 9.52 1838.69 85.75 2142.19 85.75 2142.19 72.49 2079.22 72.49 2079.22 9.52 1838.69 9.52"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1804.13,587.15c-19.32,1-32.91,5.76-39.55,14.11a20.64,20.64,0,0,0-4.57,12.5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1735.18,901.49v24.7a13.77,13.77,0,0,1,6,2.85V911.92a2.5,2.5,0,1,1,5,0v126.67a3,3,0,1,0,6,0V901.49Z",
    transform: "translate(-49.36 -8.81)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1730,930.92v-41h-36.84v160.53a2.5,2.5,0,0,1-5,0V889.92h-8.59v175.94h50.59V930.92Z",
    transform: "translate(-49.36 -8.81)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1822.68,653.77h0c-5.64-5.3-10.93-7.47-13.42-7.47a1.76,1.76,0,0,0-1.29.38c-1,1.07.49,7.21,8,14.25a32.66,32.66,0,0,0,10,6.67c2.77,1.06,4.35.83,4.74.42s.51-2-.72-4.69A32.76,32.76,0,0,0,1822.68,653.77Z",
    transform: "translate(-49.36 -8.81)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1842.45,102.48a5.43,5.43,0,1,0-5.43-5.42A5.43,5.43,0,0,0,1842.45,102.48Z",
    transform: "translate(-49.36 -8.81)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1842.45,453.92a5.43,5.43,0,1,0,5.43,5.43A5.44,5.44,0,0,0,1842.45,453.92Z",
    transform: "translate(-49.36 -8.81)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1842.45,272.77a5.43,5.43,0,1,0,5.43,5.43A5.44,5.44,0,0,0,1842.45,272.77Z",
    transform: "translate(-49.36 -8.81)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1871,18.33h-55V528.49h55Zm-28.59,68.3A10.43,10.43,0,1,1,1832,97.06,10.44,10.44,0,0,1,1842.45,86.63Zm0,383.14a10.43,10.43,0,1,1,10.43-10.42A10.44,10.44,0,0,1,1842.45,469.77Zm0-181.14a10.43,10.43,0,1,1,10.43-10.43A10.44,10.44,0,0,1,1842.45,288.63Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1838.69,
    y: 494.07,
    width: 303.5,
    height: 25.61
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1826.68,
    y: 9.52,
    width: 7.01,
    height: 510.16
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1710.7,497.48a2.71,2.71,0,1,0-2.7-2.71A2.71,2.71,0,0,0,1710.7,497.48Z",
    transform: "translate(-49.36 -8.81)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1686.19,251.79V434.58h49V251.79Zm42.45,163.56a2.5,2.5,0,1,1-5,0V390.24a2.5,2.5,0,0,1,5,0Zm0-39.33a2.5,2.5,0,0,1-5,0V264.69a2.5,2.5,0,0,1,5,0Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1629.98,
    y: 215.48,
    width: 62.71,
    height: 8.54
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1644.63,
    y: 430.78,
    width: 33.42,
    height: 21.95
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1636.83,
    y: 229.63,
    width: 49.02,
    height: 8.36
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1692.55,491.65l15.65,41.09V511.58a2.5,2.5,0,0,1,5,0v21.16l15.65-41.09c-9-2.43-10.53-18.57-10.78-25.12h-14.74C1703.08,473.08,1701.55,489.22,1692.55,491.65Zm25.85,3.12a7.7,7.7,0,1,1-7.7-7.7A7.71,7.71,0,0,1,1718.4,494.77Z",
    transform: "translate(-49.36 -8.81)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1705.9,189.39a4.8,4.8,0,1,0,9.6,0v-17.6h-9.6Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1838.69,
    y: 183.82,
    width: 303.5,
    height: 26.02
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2889.77,404.43l24.71,7.74a44.27,44.27,0,0,0,44.91-14.65l17.31-23.12h-88.33a39.27,39.27,0,0,1,1.4,30Z",
    transform: "translate(-49.36 -8.81)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2852,379.07a14.43,14.43,0,0,1,14.41,14.41,14.05,14.05,0,0,1-.45,3.5l19,6a34.32,34.32,0,1,0-65.43-20.49l19,5.94A14.46,14.46,0,0,1,2852,379.07Z",
    transform: "translate(-49.36 -8.81)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2981.05,73.13V66.34a.5.5,0,0,0-.5-.5h-44.89a.5.5,0,0,0-.5.5v6.79Z",
    transform: "translate(-49.36 -8.81)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2988,83.63a5.51,5.51,0,0,0-5.5-5.5h-2.75V91.87a2.5,2.5,0,0,1-5,0V78.13h-25.22V91.87a2.5,2.5,0,0,1-5,0V78.13h-4.77V91.87a2.5,2.5,0,0,1-5,0V78.13h-1.09a5.51,5.51,0,0,0-5.5,5.5v15H2988Z",
    transform: "translate(-49.36 -8.81)"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2702.09 476.58 2709.71 492.53 2938.54 492.53 2946.16 476.58 2944.63 476.58 2703.63 476.58 2702.09 476.58"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2852,384.07a9.43,9.43,0,0,0-8.7,5.82l17.89,5.6a9.59,9.59,0,0,0,.22-2A9.42,9.42,0,0,0,2852,384.07Z",
    transform: "translate(-49.36 -8.81)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2897.76,316.06h120.69a13.51,13.51,0,0,0,13.5-13.5V271.1h-79.57a4.5,4.5,0,0,1-4.5-4.5V148.94a4.51,4.51,0,0,1,4.5-4.5H3032V117.1a13.51,13.51,0,0,0-13.5-13.5H2897.76a13.51,13.51,0,0,0-13.5,13.5V302.56A13.51,13.51,0,0,0,2897.76,316.06Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2708.63,
    y: 463.57,
    width: 231,
    height: 8.01
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2460,186.34a3.71,3.71,0,0,1,2.72,1.2l14.2,15.36V26.06s0,0,0-.07,0,0,0-.08V13.81h-33.84v189.1l14.2-15.37A3.74,3.74,0,0,1,2460,186.34Z",
    transform: "translate(-49.36 -8.81)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2744.41,880.08H2760V575.45h-15.58a5.5,5.5,0,0,0-5.5,5.5V874.58A5.5,5.5,0,0,0,2744.41,880.08Z",
    transform: "translate(-49.36 -8.81)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2994,467.38h3v-93h-14l-19.65,26.26A49.33,49.33,0,0,1,2913.17,417l-.12,0L2779.3,375.08l-28.6,92.3H2994ZM2769.82,450.9h46.84a2.5,2.5,0,0,1,0,5h-46.84a2.5,2.5,0,0,1,0-5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2639.29,101.24H2625.1a4.87,4.87,0,0,1-4.64-3.37l-4.38-13.49a2.25,2.25,0,0,0-4.28,0l-4.38,13.49a4.87,4.87,0,0,1-4.64,3.37h-14.19a2.25,2.25,0,0,0-1.32,4.07l11.48,8.34a4.87,4.87,0,0,1,1.77,5.45l-4.39,13.49a2.25,2.25,0,0,0,3.46,2.52l11.48-8.34a4.84,4.84,0,0,1,5.73,0l11.48,8.34a2.25,2.25,0,0,0,3.46-2.52l-4.38-13.49a4.84,4.84,0,0,1,1.77-5.45l11.48-8.34a2.25,2.25,0,0,0-1.32-4.07Z",
    transform: "translate(-49.36 -8.81)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2778.49,880.08h156.75a27.53,27.53,0,0,0,27.5-27.5V603a27.53,27.53,0,0,0-27.5-27.5H2778.49Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2715.63,
    y: 566.86,
    width: 8.5,
    height: 304.19
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3032,650.48V823.89h63V650.48h-8.92v67.73a2.5,2.5,0,0,1-5,0V650.48Z",
    transform: "translate(-49.36 -8.81)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3081.18,873.55a2.6,2.6,0,0,1-.07-.56V850.15h-21V873a2.1,2.1,0,0,1-.07.56Z",
    transform: "translate(-49.36 -8.81)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3157.37,482.1h-31a2.5,2.5,0,0,1,0-5h31V461.54H3142a2.5,2.5,0,0,1,0-5h15.37v-14.1H3142a2.5,2.5,0,0,1,0-5h15.37V423.33H3142a2.5,2.5,0,0,1,0-5h15.37V404.22H3142a2.5,2.5,0,0,1,0-5h15.37V383.66h-31a2.5,2.5,0,0,1,0-5h31V363.11H3142a2.5,2.5,0,0,1,0-5h15.37V344H3142a2.5,2.5,0,0,1,0-5h15.37V324.89H3142a2.5,2.5,0,0,1,0-5h15.37v-14.1H3142a2.5,2.5,0,0,1,0-5h15.37V285.23h-31a2.5,2.5,0,0,1,0-5h31V264.67H3142a2.5,2.5,0,0,1,0-5h15.37V245.56H3142a2.5,2.5,0,0,1,0-5h15.37v-14.1H3142a2.5,2.5,0,0,1,0-5h15.37V207.35H3142a2.5,2.5,0,0,1,0-5h15.37V186.79h-31a2.5,2.5,0,0,1,0-5h31V166.24H3142a2.5,2.5,0,0,1,0-5h15.37V147.13H3142a2.5,2.5,0,0,1,0-5h15.37V128H3142a2.5,2.5,0,1,1,0-5h15.37v-14.1H3142a2.5,2.5,0,0,1,0-5h15.37V88.36h-31a2.5,2.5,0,0,1,0-5h31v-63h-79v496h79ZM3106.87,47a11,11,0,1,1,11,11A11,11,0,0,1,3106.87,47Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2982.67,
    y: 830.71,
    width: 63,
    height: 5.63
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2664.93,58.19h-102v102h102Zm-21.38,51.16-11.41,8.29,4.36,13.41a7.25,7.25,0,0,1-11.16,8.1l-11.4-8.29-11.41,8.29a7.14,7.14,0,0,1-8.52,0,7.13,7.13,0,0,1-2.63-8.1l4.36-13.41-11.41-8.29a7.25,7.25,0,0,1,4.26-13.11h14.1l4.36-13.41a7.24,7.24,0,0,1,13.78,0l4.36,13.41h14.1a7.25,7.25,0,0,1,4.26,13.11Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2428.53,
    y: 721.9,
    width: 29,
    height: 19.27
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 3068.5,
    cy: 38.19,
    r: 6
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2982.67,
    y: 630.64,
    width: 63,
    height: 6.03
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3032,634.45h63V601.22a16.41,16.41,0,0,0-16.39-16.39h-30.22A16.41,16.41,0,0,0,3032,601.22Z",
    transform: "translate(-49.36 -8.81)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3086.11,850.15V873a2.6,2.6,0,0,1-.06.56h9v-23.4Z",
    transform: "translate(-49.36 -8.81)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2969.37,33.89A11.31,11.31,0,0,0,2967,27l-5.27-6.8a4.54,4.54,0,0,0-1.14-1.05v20.4a2.5,2.5,0,1,1-5,0V19.15a4.72,4.72,0,0,0-1.14,1.05L2949.2,27a11.31,11.31,0,0,0-2.36,6.89v26.8h22.53Z",
    transform: "translate(-49.36 -8.81)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2952.88,266.1H3032V174.29h-60.08a2.5,2.5,0,0,1,0-5H3032V149.44h-79.07Zm19-63h45.85a2.5,2.5,0,0,1,0,5h-45.85a2.5,2.5,0,0,1,0-5Zm0,16.44h45.85a2.5,2.5,0,0,1,0,5h-45.85a2.5,2.5,0,0,1,0-5Zm0,16.44h45.85a2.5,2.5,0,0,1,0,5h-45.85a2.5,2.5,0,0,1,0-5Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2982.67,
    y: 820.08,
    width: 63,
    height: 5.63
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3055.12,873V850.15H3032v23.4h23.16A2.6,2.6,0,0,1,3055.12,873Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2475.19,
    y: 674.53,
    width: 29,
    height: 19.27
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2475.19,
    y: 793.55,
    width: 29,
    height: 4.73
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2521.86,
    y: 840.92,
    width: 29,
    height: 4.73
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2475.19,
    y: 746.18,
    width: 29,
    height: 4.73
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2475.19,
    y: 698.81,
    width: 29,
    height: 4.73
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2521.86,
    y: 816.64,
    width: 29,
    height: 19.27
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2475.19,
    y: 721.9,
    width: 29,
    height: 19.27
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2475.19,
    y: 769.27,
    width: 29,
    height: 19.27
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2428.53,
    y: 698.81,
    width: 29,
    height: 4.73
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2428.53,
    y: 746.18,
    width: 29,
    height: 4.73
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2428.53,
    y: 674.53,
    width: 29,
    height: 19.27
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2475.19,
    y: 840.92,
    width: 29,
    height: 4.73
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2475.19,
    y: 816.64,
    width: 29,
    height: 19.27
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2568.52,
    y: 721.9,
    width: 29,
    height: 19.27
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2568.52,
    y: 674.53,
    width: 29,
    height: 19.27
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2568.52,
    y: 746.18,
    width: 29,
    height: 4.73
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2417.92,28.49V482.16h257.51a17.52,17.52,0,0,0,17.5-17.5V46a17.52,17.52,0,0,0-17.5-17.5H2481.91V205.21a4.44,4.44,0,0,1-2.64,4.25,3.6,3.6,0,0,1-4-1h0L2460,192l-15.26,16.52a3.69,3.69,0,0,1-2.71,1.23,3.53,3.53,0,0,1-1.3-.25,4.43,4.43,0,0,1-2.65-4.25V28.49Zm140,29.2a4.51,4.51,0,0,1,4.5-4.5h103a4.5,4.5,0,0,1,4.5,4.5v103a4.5,4.5,0,0,1-4.5,4.5h-103a4.51,4.51,0,0,1-4.5-4.5Zm-12,12a2.5,2.5,0,1,1,5,0V172.2h102.49a2.5,2.5,0,0,1,0,5h-103a4.51,4.51,0,0,1-4.5-4.5Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2568.52,
    y: 840.92,
    width: 29,
    height: 4.11
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2568.52,
    y: 698.81,
    width: 29,
    height: 4.73
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2521.86,
    y: 769.27,
    width: 29,
    height: 19.27
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2521.86,
    y: 746.18,
    width: 29,
    height: 4.73
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2521.86,
    y: 721.9,
    width: 29,
    height: 19.27
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2521.86,
    y: 793.55,
    width: 29,
    height: 4.73
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2521.86,
    y: 674.53,
    width: 29,
    height: 19.27
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2521.86,
    y: 698.81,
    width: 29,
    height: 4.73
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2568.52,
    y: 768.86,
    width: 29,
    height: 67.06
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2359.55,
    y: 19.68,
    width: 4.01,
    height: 453.67
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2321.73,
    y: 651.66,
    width: 11.63,
    height: 256
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 3001.98,
    cy: 1245.83,
    r: 23.9
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2234.55,1218.71v-31.18a112.47,112.47,0,0,0-109.8,109.79h31.19A81.24,81.24,0,0,1,2234.55,1218.71Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2006.52,
    y: 993.26,
    width: 11.63,
    height: 51
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2239.32,
    y: 993.26,
    width: 11.63,
    height: 51
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2151.06,1134.13h125.1v-51h-125.1Zm62.55-43c21.82,0,45,6.13,45,17.5s-23.19,17.5-45,17.5-45-6.13-45-17.5S2191.79,1091.13,2213.61,1091.13Z",
    transform: "translate(-49.36 -8.81)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3198.59,766a30.9,30.9,0,1,0-21.84,9A30.68,30.68,0,0,0,3198.59,766Zm-38.05-21.85a16.21,16.21,0,0,1,27.67-11.46h0a16.21,16.21,0,1,1-27.67,11.46Z",
    transform: "translate(-49.36 -8.81)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2239.55,1187.53v31.18a81.26,81.26,0,0,1,78.61,78.61h31.18A112.46,112.46,0,0,0,2239.55,1187.53Z",
    transform: "translate(-49.36 -8.81)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2239.55,1223.71v73.61h73.63A76.26,76.26,0,0,0,2239.55,1223.71Z",
    transform: "translate(-49.36 -8.81)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2234.55,1223.71a76.26,76.26,0,0,0-73.64,73.61h73.64Z",
    transform: "translate(-49.36 -8.81)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3172.61,805.93h-10.36a1.5,1.5,0,0,0-1.5,1.5v205.64a1.57,1.57,0,0,0,.22.79l10.36,16.94a1.5,1.5,0,0,0,2.78-.79V807.43A1.5,1.5,0,0,0,3172.61,805.93Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2055.18,
    y: 993.26,
    width: 6.01,
    height: 51
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2042.03,
    y: 1074.32,
    width: 11.63,
    height: 51
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2335.83,1035v-14.85a1.51,1.51,0,0,0-1.33-1.49l-29-3.29v24.41l29-3.29A1.51,1.51,0,0,0,2335.83,1035Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2207.3,
    y: 993.26,
    width: 27.03,
    height: 51
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2274.83,
    y: 1074.32,
    width: 11.63,
    height: 51
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2196.29,
    y: 993.26,
    width: 6.01,
    height: 51
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2240.65,1002.06h-125.1v51h125.1Zm-62.55,43c-21.82,0-45-6.13-45-17.5s23.2-17.5,45-17.5,45,6.14,45,17.5S2199.92,1045.06,2178.1,1045.06Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2023.15,
    y: 993.26,
    width: 27.03,
    height: 51
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2178.1,1015.06c-24.8,0-40,7.28-40,12.5s15.22,12.5,40,12.5,40-7.28,40-12.5S2202.89,1015.06,2178.1,1015.06Z",
    transform: "translate(-49.36 -8.81)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3092.84,1136.64V996a22.54,22.54,0,0,0-20,22.36v118.33Z",
    transform: "translate(-49.36 -8.81)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2446.51,1264.3h187.86a38,38,0,0,0-37.91-35.5l-153.45,0v16.43a2.49,2.49,0,0,1,.87-.16h154a2.5,2.5,0,0,1,0,5h-154a2.49,2.49,0,0,1-.87-.17v10.93A3.5,3.5,0,0,0,2446.51,1264.3Z",
    transform: "translate(-49.36 -8.81)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2854.57,1299.17H2420.18a12.39,12.39,0,0,1-7.5-2.53v3a7.51,7.51,0,0,0,7.5,7.5h434.39a7.52,7.52,0,0,0,7.5-7.5v-3A12.43,12.43,0,0,1,2854.57,1299.17Z",
    transform: "translate(-49.36 -8.81)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2274.86,561.34a1.5,1.5,0,0,0-1.85-.76l-150.79,53.21h177.91Z",
    transform: "translate(-49.36 -8.81)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2640.37,1264.3h187.87a3.5,3.5,0,0,0,3.5-3.5V1250H2678.06a2.5,2.5,0,0,1,0-5h153.68v-16.27l-153.46,0A38,38,0,0,0,2640.37,1264.3Z",
    transform: "translate(-49.36 -8.81)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3212.64,996.34v17.75a9.22,9.22,0,0,0,0-17.75Z",
    transform: "translate(-49.36 -8.81)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2675.78,1223.87v-.07l2.5,0h153.46V980.87a3.5,3.5,0,0,0-3.5-3.5h-150a38,38,0,0,0-38,38v231.32A43.08,43.08,0,0,1,2675.78,1223.87Zm78.47-23.25h-44.16a2.5,2.5,0,0,1,0-5h44.16a2.5,2.5,0,0,1,0,5Zm-81.19-195.15h76.11a2.5,2.5,0,0,1,0,5h-76.11a2.5,2.5,0,0,1,0-5Zm0,16h126.15a2.5,2.5,0,0,1,0,5H2673.06a2.5,2.5,0,0,1,0-5Zm0,16h105.22a2.5,2.5,0,0,1,0,5H2673.06a2.5,2.5,0,0,1,0-5Zm0,16h126.15a2.5,2.5,0,0,1,0,5H2673.06a2.5,2.5,0,0,1,0-5Zm-2.5,31.57a6.51,6.51,0,0,1,6.5-6.5h118.15a6.5,6.5,0,0,1,6.5,6.5v93.83a6.5,6.5,0,0,1-6.5,6.5H2677.06a6.51,6.51,0,0,1-6.5-6.5Zm2.5,110.54h18.16a2.5,2.5,0,0,1,0,5h-18.16a2.5,2.5,0,0,1,0-5Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2426.04,
    y: 1008.25,
    width: 125.4,
    height: 20.44,
    rx: 1.5,
    ry: 1.5
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2599,1223.87a43.08,43.08,0,0,1,35.51,22.82V1015.37a38,38,0,0,0-38-38H2446.51a3.5,3.5,0,0,0-3.5,3.5v242.9H2599ZM2470.4,1018.55a6.51,6.51,0,0,1,6.5-6.5h122.4a6.51,6.51,0,0,1,6.5,6.5V1036a6.51,6.51,0,0,1-6.5,6.5H2476.9a6.51,6.51,0,0,1-6.5-6.5Zm2.5,52H2549a2.5,2.5,0,0,1,0,5H2472.9a2.5,2.5,0,0,1,0-5Zm0,16h126.15a2.5,2.5,0,0,1,0,5H2472.9a2.5,2.5,0,0,1,0-5Zm0,16h105.22a2.5,2.5,0,0,1,0,5H2472.9a2.5,2.5,0,0,1,0-5Zm0,16h126.15a2.5,2.5,0,0,1,0,5H2472.9a2.5,2.5,0,0,1,0-5Zm0,16h116.15a2.5,2.5,0,0,1,0,5H2472.9a2.5,2.5,0,0,1,0-5Zm0,16h126.15a2.5,2.5,0,0,1,0,5H2472.9a2.5,2.5,0,0,1,0-5Zm0,16h105.22a2.5,2.5,0,0,1,0,5H2472.9a2.5,2.5,0,0,1,0-5Zm0,21a2.5,2.5,0,0,1,0-5h126.15a2.5,2.5,0,0,1,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2626.2,
    y: 1074.77,
    width: 121.15,
    height: 96.84,
    rx: 1.5,
    ry: 1.5
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2420.18,1294.17h434.39a7.52,7.52,0,0,0,7.5-7.5V1013.88a7.51,7.51,0,0,0-7.5-7.5h-17.83V1260.8a8.51,8.51,0,0,1-8.5,8.5H2446.51a8.51,8.51,0,0,1-8.5-8.5V1006.38h-17.83a7.5,7.5,0,0,0-7.5,7.5v272.79A7.51,7.51,0,0,0,2420.18,1294.17Z",
    transform: "translate(-49.36 -8.81)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3180.89,800.93h2.68V779.4a36.18,36.18,0,0,1-14-.07v21.6h3.05a6.46,6.46,0,0,0,8.28,0Z",
    transform: "translate(-49.36 -8.81)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3179.39,1100.07a1.43,1.43,0,0,0,1.1,1.44,1.4,1.4,0,0,0,1.68-.66l10.36-16.94a1.5,1.5,0,0,0,.22-.78v-48.08h-13.36Z",
    transform: "translate(-49.36 -8.81)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3004,935.61h-68.26v203.44H3004a3.5,3.5,0,0,0,3.5-3.5V939.11A3.5,3.5,0,0,0,3004,935.61Z",
    transform: "translate(-49.36 -8.81)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3097.84,1136.64h20V1018.31a22.54,22.54,0,0,0-20-22.36Z",
    transform: "translate(-49.36 -8.81)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1931.19,685h202.37V647H1931.19Zm9.49-27.51h107.51a2.5,2.5,0,0,1,0,5H1940.68a2.5,2.5,0,0,1,0-5Zm0,12h155a2.5,2.5,0,0,1,0,5h-155a2.5,2.5,0,0,1,0-5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2393.58,635h-22.49v20.52h12.12a4.51,4.51,0,0,1,4.5,4.5V917a4.51,4.51,0,0,1-4.5,4.5h-12.12v11.79a14.67,14.67,0,0,0,4.4,10.42,13.72,13.72,0,0,0,9.86,4,14.06,14.06,0,0,0,13.73-14V640.45A5.5,5.5,0,0,0,2393.58,635Z",
    transform: "translate(-49.36 -8.81)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3195.91,1005.22a14.25,14.25,0,0,1,11.73-14V980.38h-28.25v49.67h28.25v-10.84A14.24,14.24,0,0,1,3195.91,1005.22Z",
    transform: "translate(-49.36 -8.81)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2366.09,933.26V921.47h0v-266h0V624.29a5.5,5.5,0,0,0-5.5-5.5H2055.07a4.52,4.52,0,0,1-4.21-2.93l-9.67-25.8h-75.94v24.23a4.51,4.51,0,0,1-4.5,4.5h-49.21a5.5,5.5,0,0,0-5.5,5.5v309.4a14,14,0,0,0,14,14h452.41c-.16-.14-.31-.29-.46-.44A19.73,19.73,0,0,1,2366.09,933.26ZM1978.36,604H2031a2.5,2.5,0,0,1,0,5h-52.66a2.5,2.5,0,0,1,0-5Zm160.2,81.5a4.51,4.51,0,0,1-4.5,4.5H1930.69a4.51,4.51,0,0,1-4.5-4.5v-39a4.51,4.51,0,0,1,4.5-4.5h203.37a4.51,4.51,0,0,1,4.5,4.5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2930.75,935.61h-6.18a3.5,3.5,0,0,0-3.5,3.5v196.44a3.5,3.5,0,0,0,3.5,3.5h6.18Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1758.41,
    y: 947.98,
    width: 18.81,
    height: 118.33
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1924.44 1057.41 1869.61 1057.41 1869.61 1107.23 1924.44 1121.28 1924.44 1057.41"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3139.34,1213.13a41.19,41.19,0,0,0-17.92,4.06l-3.58,1.72v-77.27h-20v12.19a17.31,17.31,0,0,1,0,34.27v63.18h0l0,2.91c0,.15,0,.3,0,.44a41.5,41.5,0,1,0,41.5-41.5Zm0,70.4a28.9,28.9,0,1,1,28.9-28.9A28.93,28.93,0,0,1,3139.34,1283.53Z",
    transform: "translate(-49.36 -8.81)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3200.91,1005.22a9.23,9.23,0,0,0,6.73,8.87V996.34A9.25,9.25,0,0,0,3200.91,1005.22Z",
    transform: "translate(-49.36 -8.81)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3188.41,710.21v-38h-23.32v38a36.19,36.19,0,0,1,23.32,0Z",
    transform: "translate(-49.36 -8.81)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3170.8,753.65a11.2,11.2,0,0,0,13.88-1.56,11.23,11.23,0,0,0,1.56-13.88Z",
    transform: "translate(-49.36 -8.81)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1990.11,1239.81a24.17,24.17,0,1,0,24.17,24.17A24.19,24.19,0,0,0,1990.11,1239.81Zm2,40.91a2.5,2.5,0,0,1,0-5,9.33,9.33,0,0,0,9.32-9.33,2.5,2.5,0,1,1,5,0A14.35,14.35,0,0,1,1992.12,1280.72Z",
    transform: "translate(-49.36 -8.81)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1839.77,905.13c.31,0,.62,0,.92,0h7.59l1.43-8.37h-36.38l1.44,8.37h7.58c.31,0,.61,0,.92,0Z",
    transform: "translate(-49.36 -8.81)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3181.39,643.84a4.64,4.64,0,1,0-9.28,0v23.39h9.28Z",
    transform: "translate(-49.36 -8.81)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1840.69,910.18h-18.34a15.51,15.51,0,0,0-14.58,15.45v26.16h23.82v128.33h-23.82v41.65h47.5V925.63A15.51,15.51,0,0,0,1840.69,910.18Zm6.75,151.29a2.5,2.5,0,0,1-5,0V969.86a2.5,2.5,0,0,1,5,0Zm0-105.27a2.5,2.5,0,1,1-5,0V926.83a2.5,2.5,0,1,1,5,0Z",
    transform: "translate(-49.36 -8.81)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1985.35,1202.94a16.17,16.17,0,1,0-16.16,16.16A16.18,16.18,0,0,0,1985.35,1202.94Z",
    transform: "translate(-49.36 -8.81)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 3089.98,
    cy: 1245.83,
    r: 23.9
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1926.27,1224.14a11.17,11.17,0,1,0,11.17,11.17A11.18,11.18,0,0,0,1926.27,1224.14Z",
    transform: "translate(-49.36 -8.81)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3180.89,805.93a1.5,1.5,0,0,0-1.5,1.5v168h13.36v-168a1.5,1.5,0,0,0-1.5-1.5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3092.83,1254.22l0-2.94h.06V1188.1a17.31,17.31,0,0,1,0-34.27v-12.19h-20v77.27l-3.58-1.72a41.51,41.51,0,1,0,23.58,37.44C3092.84,1254.49,3092.83,1254.36,3092.83,1254.22Zm-41.49,29.31a28.9,28.9,0,1,1,28.9-28.9A28.93,28.93,0,0,1,3051.34,1283.53Z",
    transform: "translate(-49.36 -8.81)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1976,1158.26a12.44,12.44,0,0,1-2.24-7.15v-15.86l-54.83-14v29.91a12.51,12.51,0,0,1-2.24,7.15L1825,1289.9a17.5,17.5,0,0,0,15.35,25.9h212a17.5,17.5,0,0,0,15.35-25.9Zm-121.79,120.21a2.45,2.45,0,0,1-1.43-.45,2.5,2.5,0,0,1-.62-3.48l65.49-94a2.5,2.5,0,1,1,4.1,2.86l-65.49,94A2.48,2.48,0,0,1,1854.25,1278.47Zm72-27a16.17,16.17,0,1,1,16.17-16.17A16.19,16.19,0,0,1,1926.27,1251.48Zm21.75-48.54a21.17,21.17,0,1,1,21.17,21.16A21.19,21.19,0,0,1,1948,1202.94Zm42.09,90.21a29.17,29.17,0,1,1,29.17-29.17A29.2,29.2,0,0,1,1990.11,1293.15Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2231.8,
    y: 1074.32,
    width: 6.01,
    height: 51
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2090.68,
    y: 1074.32,
    width: 6.01,
    height: 51
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2213.61,1121.13c24.79,0,40-7.28,40-12.5s-15.22-12.5-40-12.5-40,7.28-40,12.5S2188.81,1121.13,2213.61,1121.13Z",
    transform: "translate(-49.36 -8.81)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1842.44,848.45a1.5,1.5,0,0,0-1.5-1.5H1822.1a1.5,1.5,0,0,0-1.5,1.5v10.1h21.84Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2242.81,
    y: 1074.32,
    width: 27.03,
    height: 51
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2058.66,
    y: 1074.32,
    width: 27.03,
    height: 51
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3107.67,1171a12.33,12.33,0,1,0-12.33,12.34A12.34,12.34,0,0,0,3107.67,1171Zm-6.94-2.57-8.5,8.5a2.49,2.49,0,0,1-1.77.73,2.45,2.45,0,0,1-1.76-.73,2.49,2.49,0,0,1,0-3.53l8.5-8.5a2.5,2.5,0,1,1,3.53,3.53Z",
    transform: "translate(-49.36 -8.81)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3182.71,734.68a11.2,11.2,0,0,0-15.45,15.44Z",
    transform: "translate(-49.36 -8.81)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1976.43,1061.2a10.37,10.37,0,0,0,0-20.74h-60.09a10.37,10.37,0,0,0-10,7.87h42.79a2.5,2.5,0,0,1,0,5h-42.79a10.37,10.37,0,0,0,10,7.87Zm-15.38-12.87h16.59a2.5,2.5,0,1,1,0,5h-16.59a2.5,2.5,0,0,1,0-5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1850.56,891.81l4.7-27.46a.68.68,0,0,0-.68-.8h-46.12a.69.69,0,0,0-.53.24.74.74,0,0,0-.15.56l4.7,27.46Z",
    transform: "translate(-49.36 -8.81)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2055.88,1101.2v14.85a1.49,1.49,0,0,0,1.33,1.49l29,3.29v-24.4l-29,3.28A1.5,1.5,0,0,0,2055.88,1101.2Z",
    transform: "translate(-49.36 -8.81)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1678.85,237.83h2.34V435.08a4.51,4.51,0,0,0,4.5,4.5h3.3V462a4.51,4.51,0,0,0,4.5,4.5h4.84c-.33,7.47-2.26,19.3-7.3,20.35a4.54,4.54,0,0,0-3.1,2.28,4.47,4.47,0,0,0-.26,3.73l18.9,49.61h8.26l18.9-49.61a4.47,4.47,0,0,0-.26-3.73,4.54,4.54,0,0,0-3.1-2.28c-5-1.05-7-12.88-7.3-20.35h4.84a4.51,4.51,0,0,0,4.5-4.5V439.58h3.3a4.51,4.51,0,0,0,4.5-4.5V237.83h2.35a4.51,4.51,0,0,0,4.5-4.5V58.69a36.36,36.36,0,1,0-72.71,0V233.33A4.5,4.5,0,0,0,1678.85,237.83Zm56.36,9h-49v-8.35h49Zm-6.36,244.86-15.65,41.09V511.58a2.5,2.5,0,0,0-5,0v21.16l-15.65-41.09c9-2.43,10.53-18.57,10.78-25.12h14.74C1718.32,473.08,1719.85,489.22,1728.85,491.65Zm-1.44-30.12H1694V439.58h33.42Zm5-26.95h-46.22V251.79h49V434.58Zm-53.06-201.75v-8.54h62.71v8.54Zm31.35-205.5a31.4,31.4,0,0,1,31.36,31.36v160.6h-62.71V58.69A31.39,31.39,0,0,1,1710.7,27.33Z",
    transform: "translate(-49.36 -8.81)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1703,494.77a7.7,7.7,0,1,0,7.7-7.7A7.71,7.71,0,0,0,1703,494.77Zm7.7-2.7a2.71,2.71,0,1,1-2.7,2.7A2.7,2.7,0,0,1,1710.7,492.07Z",
    transform: "translate(-49.36 -8.81)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1700.5,171.79h.4v17.6a9.8,9.8,0,1,0,19.6,0v-17.6h.41a4.51,4.51,0,0,0,4.5-4.5V70.89a14.71,14.71,0,0,0-29.41,0v96.4A4.5,4.5,0,0,0,1700.5,171.79Zm15,17.6a4.8,4.8,0,1,1-9.6,0v-17.6h9.6ZM1701,70.89a9.71,9.71,0,0,1,19.41,0v95.9H1701Z",
    transform: "translate(-49.36 -8.81)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1710.7,72.59a2.5,2.5,0,0,0-2.5,2.5V155.7a2.5,2.5,0,1,0,5,0V75.09A2.5,2.5,0,0,0,1710.7,72.59Z",
    transform: "translate(-49.36 -8.81)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1726.14,262.19a2.5,2.5,0,0,0-2.5,2.5V376a2.5,2.5,0,0,0,5,0V264.69A2.5,2.5,0,0,0,1726.14,262.19Z",
    transform: "translate(-49.36 -8.81)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1726.14,387.74a2.5,2.5,0,0,0-2.5,2.5v25.11a2.5,2.5,0,1,0,5,0V390.24A2.5,2.5,0,0,0,1726.14,387.74Z",
    transform: "translate(-49.36 -8.81)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1815.57,533.49h376.49a4.51,4.51,0,0,0,4.5-4.5V79.62a3,3,0,0,0,0-.42,1.75,1.75,0,0,0,0-.4,2.48,2.48,0,0,0-1.06-2,4,4,0,0,0-.26-.32l-61.8-61.8-.32-.26a2.47,2.47,0,0,0-2-1.05,2.71,2.71,0,0,0-.41,0,3,3,0,0,0-.42,0H1815.57a4.49,4.49,0,0,0-4.5,4.5V529A4.5,4.5,0,0,0,1815.57,533.49Zm72.48-92.66h303.51v26H1888.05Zm0-5v-26h303.51v26Zm0-31v-26h303.51v26Zm0-31v-26h303.51v26Zm0-31v-26h303.51v26Zm0-31v-26h303.51v26Zm0-31v-26h303.51v26Zm0-31v-26h303.51v26Zm0-31v-26h303.51v26Zm0-31v-26h303.51v26Zm0-31v-26h303.51v26Zm0-31v-26h303.51v26Zm0,346.27h303.51v26H1888.05Zm245.54-450L2188,76.3h-54.43Zm58,59.44V94.56H1888.05V18.33h240.54v63ZM1883.05,528.49h-7V18.33h7Zm5,0V502.88h303.51v25.61Zm-72-510.16h55V528.49h-55Z",
    transform: "translate(-49.36 -8.81)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1842.45,107.48A10.43,10.43,0,1,0,1832,97.06,10.44,10.44,0,0,0,1842.45,107.48Zm0-15.85a5.43,5.43,0,1,1-5.43,5.43A5.44,5.44,0,0,1,1842.45,91.63Z",
    transform: "translate(-49.36 -8.81)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1842.45,267.77a10.43,10.43,0,1,0,10.43,10.43A10.44,10.44,0,0,0,1842.45,267.77Zm0,15.86a5.43,5.43,0,1,1,5.43-5.43A5.44,5.44,0,0,1,1842.45,283.63Z",
    transform: "translate(-49.36 -8.81)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1842.45,448.92a10.43,10.43,0,1,0,10.43,10.43A10.44,10.44,0,0,0,1842.45,448.92Zm0,15.85a5.43,5.43,0,1,1,5.43-5.42A5.43,5.43,0,0,1,1842.45,464.77Z",
    transform: "translate(-49.36 -8.81)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2241.76,97.29h3.79V442l16.71,41.21a2.28,2.28,0,0,0,0,.26,2.48,2.48,0,0,0,.9,1.91l6.3,15.54.07.16a4.51,4.51,0,0,0,8.09,0l6.36-15.7a2.47,2.47,0,0,0,.91-1.91c0-.09,0-.18,0-.27l16.52-40.75.18-.45V97.29h3.8a4.51,4.51,0,0,0,4.5-4.5V68.35a4.51,4.51,0,0,0-4.5-4.5h-3.8V30.74a10.51,10.51,0,0,0-10.5-10.5h-35a10.51,10.51,0,0,0-10.5,10.5V63.85h-3.79a4.51,4.51,0,0,0-4.5,4.5V92.79A4.51,4.51,0,0,0,2241.76,97.29Zm54.79,338-7.49-6V97.39h7.49ZM2280.36,481h-13.61l-16-39.43,9.78-7.83h.07l12.94,10,12.95-10h.07l9.77,7.83ZM2258,429.34l-7.49,6V97.39H2258Zm26,0-10.51,8.08L2263,429.31V97.39h21Zm-10.51,68.49L2268.77,486h9.56Zm-23-467.06a5.51,5.51,0,0,1,5.5-5.5h35a5.51,5.51,0,0,1,5.5,5.5V63.85h-46Zm-8.29,38.11h62.59V92.29h-62.59Z",
    transform: "translate(-49.36 -8.81)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2258.79,34a2.5,2.5,0,0,0-2.5,2.5V53a2.5,2.5,0,0,0,5,0V36.48A2.5,2.5,0,0,0,2258.79,34Z",
    transform: "translate(-49.36 -8.81)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2460,186.34a3.71,3.71,0,0,1,2.72,1.2l14.2,15.36V26.06s0,0,0-.07,0,0,0-.08V13.81h-33.84v189.1l14.2-15.37A3.74,3.74,0,0,1,2460,186.34Z",
    transform: "translate(-49.36 -8.81)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2377.91,50.49h8.59a2.5,2.5,0,0,1,0,5h-8.59v22h8.59a2.5,2.5,0,0,1,0,5h-8.59v22h8.59a2.5,2.5,0,0,1,0,5h-8.59v22h8.59a2.5,2.5,0,0,1,0,5h-8.59v22h8.59a2.5,2.5,0,0,1,0,5h-8.59v22h8.59a2.5,2.5,0,0,1,0,5h-8.59v22h8.59a2.5,2.5,0,0,1,0,5h-8.59v22h8.59a2.5,2.5,0,0,1,0,5h-8.59v22h8.59a2.5,2.5,0,0,1,0,5h-8.59v22h8.59a2.5,2.5,0,0,1,0,5h-8.59v22h8.59a2.5,2.5,0,0,1,0,5h-8.59v22h8.59a2.5,2.5,0,0,1,0,5h-8.59v22h8.59a2.5,2.5,0,0,1,0,5h-8.59v22h8.59a2.5,2.5,0,0,1,0,5h-8.59v22h8.59a2.5,2.5,0,0,1,0,5h-8.59v22h8.59a2.5,2.5,0,0,1,0,5h-8.59v22h26V28.49h-26Z",
    transform: "translate(-49.36 -8.81)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2675.43,28.49H2481.91V205.21a4.44,4.44,0,0,1-2.64,4.25,3.6,3.6,0,0,1-4-1h0L2460,192l-15.26,16.52a3.69,3.69,0,0,1-2.71,1.23,3.53,3.53,0,0,1-1.3-.25,4.43,4.43,0,0,1-2.65-4.25V28.49h-20.15V482.16h257.51a17.52,17.52,0,0,0,17.5-17.5V46A17.52,17.52,0,0,0,2675.43,28.49Z",
    transform: "translate(-49.36 -8.81)"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2359.55,
    y: 19.68,
    width: 4.01,
    height: 453.67
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2675.43,23.49H2481.91V13.31a4.5,4.5,0,0,0-4.5-4.5h-34.84a4.5,4.5,0,0,0-4.5,4.5V23.49h-60.66a4.5,4.5,0,0,0-4.5,4.5v22.5H2361a2.5,2.5,0,0,0,0,5h11.91v22H2361a2.5,2.5,0,0,0,0,5h11.91v22H2361a2.5,2.5,0,0,0,0,5h11.91v22H2361a2.5,2.5,0,0,0,0,5h11.91v22H2361a2.5,2.5,0,0,0,0,5h11.91v22H2361a2.5,2.5,0,0,0,0,5h11.91v22H2361a2.5,2.5,0,0,0,0,5h11.91v22H2361a2.5,2.5,0,0,0,0,5h11.91v22H2361a2.5,2.5,0,0,0,0,5h11.91v22H2361a2.5,2.5,0,0,0,0,5h11.91v22H2361a2.5,2.5,0,0,0,0,5h11.91v22H2361a2.5,2.5,0,0,0,0,5h11.91v22H2361a2.5,2.5,0,0,0,0,5h11.91v22H2361a2.5,2.5,0,0,0,0,5h11.91v22H2361a2.5,2.5,0,0,0,0,5h11.91v22H2361a2.5,2.5,0,0,0,0,5h11.91v22.51a4.51,4.51,0,0,0,4.5,4.5h298a22.52,22.52,0,0,0,22.5-22.5V46A22.52,22.52,0,0,0,2675.43,23.49Zm-232.36-9.68h33.84v12.1s0,.05,0,.08,0,0,0,.07V202.9l-14.2-15.36a3.68,3.68,0,0,0-5.44,0l-14.2,15.37Zm-39.16,468.35h-26v-22h8.59a2.5,2.5,0,0,0,0-5h-8.59v-22h8.59a2.5,2.5,0,0,0,0-5h-8.59v-22h8.59a2.5,2.5,0,0,0,0-5h-8.59v-22h8.59a2.5,2.5,0,0,0,0-5h-8.59v-22h8.59a2.5,2.5,0,0,0,0-5h-8.59v-22h8.59a2.5,2.5,0,0,0,0-5h-8.59v-22h8.59a2.5,2.5,0,0,0,0-5h-8.59v-22h8.59a2.5,2.5,0,0,0,0-5h-8.59v-22h8.59a2.5,2.5,0,0,0,0-5h-8.59v-22h8.59a2.5,2.5,0,0,0,0-5h-8.59v-22h8.59a2.5,2.5,0,0,0,0-5h-8.59v-22h8.59a2.5,2.5,0,0,0,0-5h-8.59v-22h8.59a2.5,2.5,0,0,0,0-5h-8.59v-22h8.59a2.5,2.5,0,0,0,0-5h-8.59v-22h8.59a2.5,2.5,0,0,0,0-5h-8.59v-22h8.59a2.5,2.5,0,0,0,0-5h-8.59v-22h26Zm9,0h-4V28.49h4Zm280-17.5a17.52,17.52,0,0,1-17.5,17.5H2417.92V28.49h20.15V205.21a4.43,4.43,0,0,0,2.65,4.25,3.53,3.53,0,0,0,1.3.25,3.69,3.69,0,0,0,2.71-1.23L2460,192l15.26,16.52h0a3.6,3.6,0,0,0,4,1,4.44,4.44,0,0,0,2.64-4.25V28.49h193.52a17.52,17.52,0,0,1,17.5,17.5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2562.44,165.19h103a4.5,4.5,0,0,0,4.5-4.5v-103a4.5,4.5,0,0,0-4.5-4.5h-103a4.51,4.51,0,0,0-4.5,4.5v103A4.51,4.51,0,0,0,2562.44,165.19Zm.5-107h102v102h-102Z",
    transform: "translate(-49.36 -8.81)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2550.43,177.2h103a2.5,2.5,0,0,0,0-5H2550.93V69.7a2.5,2.5,0,1,0-5,0v103A4.51,4.51,0,0,0,2550.43,177.2Z",
    transform: "translate(-49.36 -8.81)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2393.58,630h-22.49v-5.66a10.51,10.51,0,0,0-10.5-10.5h-54.91l-26.32-54.62a6.48,6.48,0,0,0-8-3.3l-164.15,57.92h-51.77L2046.14,589a4.5,4.5,0,0,0-4.46-4h-76.93a4.51,4.51,0,0,0-4.5,4.5v24.23h-48.71a10.51,10.51,0,0,0-10.5,10.5v309.4a19,19,0,0,0,19,19h468.65a2.49,2.49,0,0,0,1.83-.8,19.12,19.12,0,0,0,13.56-18.2V640.45A10.51,10.51,0,0,0,2393.58,630Zm-22.49,30.52h11.62v256h-11.62ZM2273,560.58a1.5,1.5,0,0,1,1.85.76l25.27,52.45H2122.22ZM1920,947.69a14,14,0,0,1-14-14V624.29a5.5,5.5,0,0,1,5.5-5.5h49.21a4.51,4.51,0,0,0,4.5-4.5V590.06h75.94l9.67,25.8a4.52,4.52,0,0,0,4.21,2.93h305.52a5.5,5.5,0,0,1,5.5,5.5v31.18h0v266h0v11.79a19.73,19.73,0,0,0,5.9,14c.15.15.3.3.46.44Zm479-14a14.06,14.06,0,0,1-13.73,14,13.72,13.72,0,0,1-9.86-4,14.67,14.67,0,0,1-4.4-10.42V921.47h12.12a4.51,4.51,0,0,0,4.5-4.5V660a4.51,4.51,0,0,0-4.5-4.5h-12.12V635h22.49a5.5,5.5,0,0,1,5.5,5.5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1978.36,609H2031a2.5,2.5,0,0,0,0-5h-52.66a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2134.06,642H1930.69a4.51,4.51,0,0,0-4.5,4.5v39a4.51,4.51,0,0,0,4.5,4.5h203.37a4.51,4.51,0,0,0,4.5-4.5v-39A4.51,4.51,0,0,0,2134.06,642Zm-.5,43H1931.19V647h202.37Z",
    transform: "translate(-49.36 -8.81)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1940.68,662.46h107.51a2.5,2.5,0,0,0,0-5H1940.68a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1940.68,674.47h155a2.5,2.5,0,0,0,0-5h-155a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2748,229.84a2.5,2.5,0,0,0,2.5-2.5V64.83a2.48,2.48,0,0,0-.3-1.17,2.41,2.41,0,0,0,.3-1.16,35,35,0,1,1,70,0,2.42,2.42,0,0,0,.31,1.16,2.49,2.49,0,0,0-.31,1.17V234.51a28.5,28.5,0,1,1-57,0V100a22.09,22.09,0,1,1,44.18,0V233.29a15.89,15.89,0,1,1-31.78,0V103.34a2.5,2.5,0,0,0-5,0v130a20.89,20.89,0,1,0,41.78,0V100a27.09,27.09,0,1,0-54.18,0V234.51a33.5,33.5,0,1,0,67,0V64.83a2.48,2.48,0,0,0-.3-1.17,2.41,2.41,0,0,0,.3-1.16,40,40,0,1,0-80,0,2.53,2.53,0,0,0,.3,1.16,2.6,2.6,0,0,0-.3,1.17V227.34A2.5,2.5,0,0,0,2748,229.84Z",
    transform: "translate(-49.36 -8.81)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1837.81,763.08c10.73-25.88,14.91-54.89,16.69-67.28.19-1.31.35-2.45.51-3.45a80.29,80.29,0,0,0-2.76-29.92c-4.27-14.3-15-32.18-42.09-36.18a63.94,63.94,0,0,0-50.86,13.94v-18a25.6,25.6,0,0,0,12.44,3.23,27.23,27.23,0,0,0,5-.48c13.87-2.65,27-15.81,38.93-39.11l.63-1.24-1.54-2.56h-1.39c-26.18-.28-44,5.14-52.72,16.17-.5.63-.94,1.26-1.36,1.89V587.56a2.5,2.5,0,1,0-5,0v52.5a64,64,0,0,0-50.72-13.81c-27,4-37.81,21.88-42.08,36.18a80,80,0,0,0-2.75,30c.14.94.31,2.08.49,3.39,1.79,12.39,6,41.4,16.7,67.28,13.61,32.84,33.06,50,57.81,50.87.69,0,1.37,0,2,0a44.48,44.48,0,0,0,21.07-5A45.21,45.21,0,0,0,1780,814C1804.74,813,1824.19,795.92,1837.81,763.08ZM1775.92,620a20.88,20.88,0,0,1-13.52-1.81l44.54-26.86C1797.08,608,1786.44,617.91,1775.92,620Zm-11.34-18.71c6.64-8.35,20.23-13.16,39.55-14.11L1760,613.76A20.64,20.64,0,0,1,1764.58,601.26ZM1779.81,809a40.19,40.19,0,0,1-21-4.59l-1.92-1.07-1.23.7a39.87,39.87,0,0,1-21.69,5c-35.59-1.32-59-39.63-69.74-113.87-.19-1.33-.35-2.48-.49-3.37a76.29,76.29,0,0,1,2.63-28c5.63-18.69,18.41-29.63,38-32.53a62.22,62.22,0,0,1,9.13-.68,59.6,59.6,0,0,1,40.85,16.31v8.47c-9.89-.6-18.86-4.71-23.82-11a2.5,2.5,0,1,0-3.94,3.08c6.3,8,17.89,13.06,30.26,13.06s24-5,30.25-13.06a2.5,2.5,0,0,0-3.94-3.08c-4.95,6.34-13.92,10.45-23.81,11V647a59.6,59.6,0,0,1,50.13-15.78c19.57,2.9,32.35,13.84,38,32.53a76.41,76.41,0,0,1,2.64,27.94c-.14,1-.31,2.1-.5,3.43C1838.86,769.33,1815.4,807.64,1779.81,809Z",
    transform: "translate(-49.36 -8.81)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1826.1,650.13h0c-7.44-7-17.31-11.62-21.77-6.87s.74,14.31,8.18,21.31a37.22,37.22,0,0,0,11.61,7.69,14.73,14.73,0,0,0,5.21,1.11,6.59,6.59,0,0,0,5-1.92c1.21-1.29,2.85-4.33.19-10.19A37.16,37.16,0,0,0,1826.1,650.13Zm4.55,17.89c-.39.41-2,.64-4.74-.42a32.66,32.66,0,0,1-10-6.67c-7.48-7-9-13.18-8-14.25a1.76,1.76,0,0,1,1.29-.38c2.49,0,7.78,2.17,13.42,7.47h0a32.76,32.76,0,0,1,7.25,9.56C1831.16,666,1831,667.62,1830.65,668Z",
    transform: "translate(-49.36 -8.81)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2750,472.38h3v8h-2.33a4.51,4.51,0,0,0-4.06,6.44l8.1,16.94a4.5,4.5,0,0,0,4.06,2.56h229.46a4.51,4.51,0,0,0,4.06-2.56l8.1-16.94a4.51,4.51,0,0,0-4.06-6.44H2994v-8h3.5a4.51,4.51,0,0,0,4.5-4.5V374.4h.54c.61,0,15,.16,15,13.77a2.5,2.5,0,1,0,5,0c0-9.72-5.54-14.34-10.2-16.5a25.76,25.76,0,0,0-9.8-2.27h-116a2.53,2.53,0,0,0-.87.16A39.3,39.3,0,0,0,2814.78,381l-34.47-10.79a4.49,4.49,0,0,0-5.7,3.16l-28.93,93.36,0,.17a4.51,4.51,0,0,0,4.38,5.53Zm245.51,13-7.62,15.94H2759.07l-7.62-15.94h244.07Zm-6.53-5H2758v-8h231Zm-12.29-106-17.31,23.12a44.27,44.27,0,0,1-44.91,14.65l-24.71-7.74a39.27,39.27,0,0,0-1.4-30Zm-123.92-17.64A34.33,34.33,0,0,1,2885,402.94l-19-6a14.05,14.05,0,0,0,.45-3.5,14.42,14.42,0,0,0-27.9-5.09l-19-5.94A34.39,34.39,0,0,1,2852.78,356.76Zm8.43,38.73-17.89-5.6a9.41,9.41,0,0,1,18.11,3.59A9.59,9.59,0,0,1,2861.21,395.49Zm-81.91-20.41L2913.05,417l.12,0a49.33,49.33,0,0,0,50.12-16.34l19.65-26.26h14v93H2750.7Z",
    transform: "translate(-49.36 -8.81)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2769.82,455.9h46.84a2.5,2.5,0,0,0,0-5h-46.84a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2897.76,321.06h120.69a18.52,18.52,0,0,0,18.5-18.5V117.1a18.52,18.52,0,0,0-18.5-18.5H2993v-15a10.5,10.5,0,0,0-7-9.87V66.34a5.5,5.5,0,0,0-5.5-5.5h-6.18V33.89a16.3,16.3,0,0,0-3.41-9.95l-5.26-6.81a9.55,9.55,0,0,0-7.6-3.72h0a9.55,9.55,0,0,0-7.59,3.72l-5.27,6.81a16.35,16.35,0,0,0-3.4,10v27h-6.18a5.5,5.5,0,0,0-5.5,5.5v7.42a10.5,10.5,0,0,0-7,9.87v15h-25.43a18.52,18.52,0,0,0-18.5,18.5V302.56A18.52,18.52,0,0,0,2897.76,321.06Zm49.08-287.17A11.31,11.31,0,0,1,2949.2,27l5.26-6.8a4.72,4.72,0,0,1,1.14-1.05v20.4a2.5,2.5,0,1,0,5,0V19.15a4.54,4.54,0,0,1,1.14,1.05L2967,27a11.31,11.31,0,0,1,2.36,6.89v26.8h-22.53ZM3032,169.29h-60.08a2.5,2.5,0,0,0,0,5H3032V266.1h-79.07V149.44H3032ZM2935.16,66.34a.5.5,0,0,1,.5-.5h44.89a.5.5,0,0,1,.5.5v6.79h-45.89Zm-7,17.29a5.51,5.51,0,0,1,5.5-5.5h1.09V91.87a2.5,2.5,0,0,0,5,0V78.13h4.77V91.87a2.5,2.5,0,0,0,5,0V78.13h25.22V91.87a2.5,2.5,0,0,0,5,0V78.13h2.75a5.51,5.51,0,0,1,5.5,5.5v15h-59.83Zm-43.93,33.47a13.51,13.51,0,0,1,13.5-13.5h120.69a13.51,13.51,0,0,1,13.5,13.5v27.34h-79.57a4.51,4.51,0,0,0-4.5,4.5V266.6a4.5,4.5,0,0,0,4.5,4.5H3032v31.46a13.51,13.51,0,0,1-13.5,13.5H2897.76a13.51,13.51,0,0,1-13.5-13.5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2971.87,208.07h45.85a2.5,2.5,0,0,0,0-5h-45.85a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2971.87,224.51h45.85a2.5,2.5,0,0,0,0-5h-45.85a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2971.87,241h45.85a2.5,2.5,0,0,0,0-5h-45.85a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3128.86,47a11,11,0,1,0-11,11A11,11,0,0,0,3128.86,47Zm-11,6a6,6,0,1,1,6-6A6,6,0,0,1,3117.87,53Z",
    transform: "translate(-49.36 -8.81)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3077.86,521.28h80a4.51,4.51,0,0,0,4.5-4.5V19.83a4.51,4.51,0,0,0-4.5-4.5h-80a4.51,4.51,0,0,0-4.5,4.5v497A4.51,4.51,0,0,0,3077.86,521.28Zm.5-500.95h79v63h-31a2.5,2.5,0,0,0,0,5h31v15.56H3142a2.5,2.5,0,0,0,0,5h15.37V123H3142a2.5,2.5,0,1,0,0,5h15.37v14.11H3142a2.5,2.5,0,0,0,0,5h15.37v14.11H3142a2.5,2.5,0,0,0,0,5h15.37v15.55h-31a2.5,2.5,0,0,0,0,5h31v15.56H3142a2.5,2.5,0,0,0,0,5h15.37v14.11H3142a2.5,2.5,0,0,0,0,5h15.37v14.1H3142a2.5,2.5,0,0,0,0,5h15.37v14.11H3142a2.5,2.5,0,0,0,0,5h15.37v15.56h-31a2.5,2.5,0,0,0,0,5h31v15.56H3142a2.5,2.5,0,0,0,0,5h15.37v14.1H3142a2.5,2.5,0,0,0,0,5h15.37V339H3142a2.5,2.5,0,0,0,0,5h15.37v14.11H3142a2.5,2.5,0,0,0,0,5h15.37v15.55h-31a2.5,2.5,0,0,0,0,5h31v15.56H3142a2.5,2.5,0,0,0,0,5h15.37v14.11H3142a2.5,2.5,0,0,0,0,5h15.37v14.11H3142a2.5,2.5,0,0,0,0,5h15.37v14.1H3142a2.5,2.5,0,0,0,0,5h15.37V477.1h-31a2.5,2.5,0,0,0,0,5h31v34.18h-79Z",
    transform: "translate(-49.36 -8.81)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2072,1287.26l-91.85-131.86a7.49,7.49,0,0,1-1.34-4.29V1066a15.36,15.36,0,0,0-2.37-30.54h-60.09A15.36,15.36,0,0,0,1914,1066v85.11a7.5,7.5,0,0,1-1.35,4.29l-91.77,131.75-.14.22a22.5,22.5,0,0,0,19.67,33.43h212a22.5,22.5,0,0,0,19.66-33.43Zm-153-221h54.83v63.88L1919,1116Zm-12.68-12.88h42.79a2.5,2.5,0,0,0,0-5h-42.79a10.37,10.37,0,0,1,10-7.87h60.09a10.37,10.37,0,0,1,0,20.74h-60.09A10.37,10.37,0,0,1,1906.29,1053.33Zm161.18,253.84a17.35,17.35,0,0,1-15.08,8.63h-212a17.5,17.5,0,0,1-15.35-25.9l91.7-131.64a12.51,12.51,0,0,0,2.24-7.15V1121.2l54.83,14v15.86a12.44,12.44,0,0,0,2.24,7.15l91.7,131.64A17.32,17.32,0,0,1,2067.47,1307.17Z",
    transform: "translate(-49.36 -8.81)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1921.17,1179.9a2.5,2.5,0,0,0-3.48.62l-65.49,94a2.5,2.5,0,0,0,.62,3.48,2.45,2.45,0,0,0,1.43.45,2.48,2.48,0,0,0,2-1.07l65.49-94A2.5,2.5,0,0,0,1921.17,1179.9Z",
    transform: "translate(-49.36 -8.81)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1990.11,1234.81a29.17,29.17,0,1,0,29.17,29.17A29.2,29.2,0,0,0,1990.11,1234.81Zm0,53.34a24.17,24.17,0,1,1,24.17-24.17A24.2,24.2,0,0,1,1990.11,1288.15Z",
    transform: "translate(-49.36 -8.81)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2003.94,1263.89a2.5,2.5,0,0,0-2.5,2.5,9.33,9.33,0,0,1-9.32,9.33,2.5,2.5,0,0,0,0,5,14.35,14.35,0,0,0,14.32-14.33A2.5,2.5,0,0,0,2003.94,1263.89Z",
    transform: "translate(-49.36 -8.81)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1926.27,1219.14a16.17,16.17,0,1,0,16.17,16.17A16.19,16.19,0,0,0,1926.27,1219.14Zm0,27.34a11.17,11.17,0,1,1,11.17-11.17A11.18,11.18,0,0,1,1926.27,1246.48Z",
    transform: "translate(-49.36 -8.81)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1990.35,1202.94a21.17,21.17,0,1,0-21.16,21.16A21.18,21.18,0,0,0,1990.35,1202.94Zm-37.33,0a16.17,16.17,0,1,1,16.17,16.16A16.18,16.18,0,0,1,1953,1202.94Z",
    transform: "translate(-49.36 -8.81)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1961.05,1053.33h16.59a2.5,2.5,0,1,0,0-5h-16.59a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3139.34,1225.73a28.9,28.9,0,1,0,28.9,28.9A28.93,28.93,0,0,0,3139.34,1225.73Zm0,52.8a23.9,23.9,0,1,1,23.9-23.9A23.93,23.93,0,0,1,3139.34,1278.53Z",
    transform: "translate(-49.36 -8.81)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3051.34,1225.73a28.9,28.9,0,1,0,28.9,28.9A28.94,28.94,0,0,0,3051.34,1225.73Zm0,52.8a23.9,23.9,0,1,1,23.9-23.9A23.93,23.93,0,0,1,3051.34,1278.53Z",
    transform: "translate(-49.36 -8.81)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3139.34,1208.13a45.92,45.92,0,0,0-16.5,3V1018.31a27.5,27.5,0,1,0-55,0v192.84a46.5,46.5,0,1,0,27.5,58.54,46.5,46.5,0,1,0,44-61.56Zm-21.5-189.82v118.33h-20V996A22.54,22.54,0,0,1,3117.84,1018.31Zm-25-22.36v140.69h-20V1018.31A22.54,22.54,0,0,1,3092.84,996Zm-41.5,300.18a41.5,41.5,0,1,1,17.92-78.94l3.58,1.72v-77.27h20v12.19a17.31,17.31,0,0,0,0,34.27v63.18h-.06l0,2.94c0,.14,0,.27,0,.41A41.54,41.54,0,0,1,3051.34,1296.13Zm44-112.83a12.34,12.34,0,1,1,12.33-12.34A12.34,12.34,0,0,1,3095.34,1183.3Zm44,112.83a41.54,41.54,0,0,1-41.5-41.5c0-.14,0-.29,0-.44l0-2.91h0V1188.1a17.31,17.31,0,0,0,0-34.27v-12.19h20v77.27l3.58-1.72a41.5,41.5,0,1,1,17.92,78.94Z",
    transform: "translate(-49.36 -8.81)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3097.2,1164.86l-8.5,8.5a2.49,2.49,0,0,0,0,3.53,2.45,2.45,0,0,0,1.76.73,2.49,2.49,0,0,0,1.77-.73l8.5-8.5a2.5,2.5,0,1,0-3.53-3.53Z",
    transform: "translate(-49.36 -8.81)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3027,601.22V873.69a4.87,4.87,0,0,0,4.86,4.86h63.28a4.87,4.87,0,0,0,4.86-4.86V601.22a21.42,21.42,0,0,0-21.39-21.39h-30.22A21.41,21.41,0,0,0,3027,601.22Zm33.09,248.93h21V873a2.6,2.6,0,0,0,.07.56h-21.13a2.1,2.1,0,0,0,.07-.56Zm-28.09-5v-5.63h63v5.63Zm51.58-124.44a2.49,2.49,0,0,0,2.5-2.5V650.48H3095V823.89h-63V650.48h49.08v67.73A2.5,2.5,0,0,0,3083.61,720.71ZM3095,828.89v5.63h-63v-5.63Zm0-183.41h-63v-6h63Zm-63,204.67h23.09V873a2.6,2.6,0,0,0,.07.56H3032Zm54,23.4a2.6,2.6,0,0,0,.06-.56V850.15H3095v23.4Zm-37.63-288.72h30.22A16.41,16.41,0,0,1,3095,601.22v33.23h-63V601.22A16.41,16.41,0,0,1,3048.42,584.83Z",
    transform: "translate(-49.36 -8.81)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1860.27,1123.27V925.63a20.46,20.46,0,0,0-8.45-16.55,4,4,0,0,0,1.25-2.3l7.12-41.59a5.69,5.69,0,0,0-5.61-6.64h-7.14v-10.1a6.51,6.51,0,0,0-6.5-6.5H1822.1a6.51,6.51,0,0,0-6.5,6.5v10.1h-7.14a5.69,5.69,0,0,0-5.61,6.64l7.12,41.59a4,4,0,0,0,1.26,2.3,20.45,20.45,0,0,0-8.46,16.55v197.64a3.5,3.5,0,0,0,3.5,3.5h50.5A3.5,3.5,0,0,0,1860.27,1123.27ZM1820.6,848.45a1.5,1.5,0,0,1,1.5-1.5h18.84a1.5,1.5,0,0,1,1.5,1.5v10.1H1820.6Zm-12.67,15.34a.69.69,0,0,1,.53-.24h46.12a.68.68,0,0,1,.68.8l-4.7,27.46h-38.08l-4.7-27.46A.74.74,0,0,1,1807.93,863.79Zm6.84,41.39-1.44-8.37h36.38l-1.43,8.37h-7.59c-.3,0-.61,0-.92,0h-16.5c-.31,0-.61,0-.92,0Zm-7,51.61h18.82v118.33h-18.82Zm47.5,165h-47.5v-41.65h23.82V951.79h-23.82V925.63a15.51,15.51,0,0,1,14.58-15.45h18.34a15.51,15.51,0,0,1,14.58,15.45Z",
    transform: "translate(-49.36 -8.81)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1844.94,967.36a2.5,2.5,0,0,0-2.5,2.5v91.61a2.5,2.5,0,0,0,5,0V969.86A2.5,2.5,0,0,0,1844.94,967.36Z",
    transform: "translate(-49.36 -8.81)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1844.94,924.33a2.5,2.5,0,0,0-2.5,2.5V956.2a2.5,2.5,0,1,0,5,0V926.83A2.5,2.5,0,0,0,1844.94,924.33Z",
    transform: "translate(-49.36 -8.81)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2639.29,96.24h-14.1l-4.36-13.41a7.24,7.24,0,0,0-13.78,0l-4.36,13.41h-14.1a7.25,7.25,0,0,0-4.26,13.11l11.41,8.29-4.36,13.41a7.13,7.13,0,0,0,2.63,8.1,7.14,7.14,0,0,0,8.52,0l11.41-8.29,11.4,8.29a7.25,7.25,0,0,0,11.16-8.1l-4.36-13.41,11.41-8.29a7.25,7.25,0,0,0-4.26-13.11Zm1.32,9.07-11.48,8.34a4.84,4.84,0,0,0-1.77,5.45l4.38,13.49a2.25,2.25,0,0,1-3.46,2.52l-11.48-8.34a4.84,4.84,0,0,0-5.73,0l-11.48,8.34a2.25,2.25,0,0,1-3.46-2.52l4.39-13.49a4.87,4.87,0,0,0-1.77-5.45l-11.48-8.34a2.25,2.25,0,0,1,1.32-4.07h14.19a4.87,4.87,0,0,0,4.64-3.37l4.38-13.49a2.25,2.25,0,0,1,4.28,0l4.38,13.49a4.87,4.87,0,0,0,4.64,3.37h14.19a2.25,2.25,0,0,1,1.32,4.07Z",
    transform: "translate(-49.36 -8.81)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2659.39,549.65h-194a18.52,18.52,0,0,0-18.5,18.5V886.49a18.52,18.52,0,0,0,18.5,18.5h194a18.52,18.52,0,0,0,18.5-18.5V568.15A18.52,18.52,0,0,0,2659.39,549.65Zm-207.5,104.2h221V880.49a5.51,5.51,0,0,1-5.5,5.5h-210a5.5,5.5,0,0,1-5.5-5.5Zm221-5h-221v-56h221ZM2659.39,900h-194a13.51,13.51,0,0,1-13.11-10.34,10.38,10.38,0,0,0,5.11,1.34h210a10.44,10.44,0,0,0,5.11-1.34A13.52,13.52,0,0,1,2659.39,900Zm13.5-312.18h-221V568.15a13.51,13.51,0,0,1,13.5-13.5h194a13.52,13.52,0,0,1,13.5,13.5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2617.38,858.84h30a4.51,4.51,0,0,0,4.5-4.5V777.17a4.51,4.51,0,0,0-4.5-4.5h-30a4.51,4.51,0,0,0-4.5,4.5v77.17A4.51,4.51,0,0,0,2617.38,858.84Zm.5-5v-4.11h29v4.11Zm29-76.17v67.06h-29V777.67Z",
    transform: "translate(-49.36 -8.81)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2475.39,637.14h34a2.5,2.5,0,0,0,0-5h-34a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2477.39,717.34h30a4.51,4.51,0,0,0,4.5-4.5v-30a4.51,4.51,0,0,0-4.5-4.5h-30a4.51,4.51,0,0,0-4.5,4.5v30A4.51,4.51,0,0,0,2477.39,717.34Zm.5-5v-4.73h29v4.73Zm29-29v19.27h-29V683.34Z",
    transform: "translate(-49.36 -8.81)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2524.05,717.34h30a4.5,4.5,0,0,0,4.5-4.5v-30a4.5,4.5,0,0,0-4.5-4.5h-30a4.51,4.51,0,0,0-4.5,4.5v30A4.51,4.51,0,0,0,2524.05,717.34Zm.5-5v-4.73h29v4.73Zm29-29v19.27h-29V683.34Z",
    transform: "translate(-49.36 -8.81)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2570.72,717.34h30a4.51,4.51,0,0,0,4.5-4.5v-30a4.51,4.51,0,0,0-4.5-4.5h-30a4.51,4.51,0,0,0-4.5,4.5v30A4.51,4.51,0,0,0,2570.72,717.34Zm.5-5v-4.73h29v4.73Zm29-29v19.27h-29V683.34Z",
    transform: "translate(-49.36 -8.81)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2617.38,717.34h30a4.51,4.51,0,0,0,4.5-4.5v-30a4.51,4.51,0,0,0-4.5-4.5h-30a4.51,4.51,0,0,0-4.5,4.5v30A4.51,4.51,0,0,0,2617.38,717.34Zm.5-5v-4.73h29v4.73Zm29-29v19.27h-29V683.34Z",
    transform: "translate(-49.36 -8.81)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2477.39,812.08h30a4.51,4.51,0,0,0,4.5-4.5v-30a4.51,4.51,0,0,0-4.5-4.5h-30a4.51,4.51,0,0,0-4.5,4.5v30A4.51,4.51,0,0,0,2477.39,812.08Zm.5-5v-4.73h29v4.73Zm29-29v19.27h-29V778.08Z",
    transform: "translate(-49.36 -8.81)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2524.05,812.08h30a4.5,4.5,0,0,0,4.5-4.5v-30a4.5,4.5,0,0,0-4.5-4.5h-30a4.51,4.51,0,0,0-4.5,4.5v30A4.51,4.51,0,0,0,2524.05,812.08Zm.5-5v-4.73h29v4.73Zm29-29v19.27h-29V778.08Z",
    transform: "translate(-49.36 -8.81)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2570.72,812.08h30a4.51,4.51,0,0,0,4.5-4.5v-30a4.51,4.51,0,0,0-4.5-4.5h-30a4.51,4.51,0,0,0-4.5,4.5v30A4.51,4.51,0,0,0,2570.72,812.08Zm.5-5v-4.73h29v4.73Zm29-29v19.27h-29V778.08Z",
    transform: "translate(-49.36 -8.81)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2477.39,859.45h30a4.51,4.51,0,0,0,4.5-4.5V825a4.51,4.51,0,0,0-4.5-4.5h-30a4.51,4.51,0,0,0-4.5,4.5v30A4.51,4.51,0,0,0,2477.39,859.45Zm.5-5v-4.72h29v4.72Zm29-29v19.28h-29V825.45Z",
    transform: "translate(-49.36 -8.81)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2524.05,859.45h30a4.5,4.5,0,0,0,4.5-4.5V825a4.5,4.5,0,0,0-4.5-4.5h-30a4.51,4.51,0,0,0-4.5,4.5v30A4.51,4.51,0,0,0,2524.05,859.45Zm.5-5v-4.72h29v4.72Zm29-29v19.28h-29V825.45Z",
    transform: "translate(-49.36 -8.81)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2570.72,859.45h30a4.51,4.51,0,0,0,4.5-4.5V825a4.51,4.51,0,0,0-4.5-4.5h-30a4.51,4.51,0,0,0-4.5,4.5v30A4.51,4.51,0,0,0,2570.72,859.45Zm.5-5v-4.72h29v4.72Zm29-29v19.28h-29V825.45Z",
    transform: "translate(-49.36 -8.81)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2477.39,764.71h30a4.51,4.51,0,0,0,4.5-4.5v-30a4.51,4.51,0,0,0-4.5-4.5h-30a4.51,4.51,0,0,0-4.5,4.5v30A4.51,4.51,0,0,0,2477.39,764.71Zm.5-5V755h29v4.73Zm29-29V750h-29V730.71Z",
    transform: "translate(-49.36 -8.81)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2524.05,764.71h30a4.5,4.5,0,0,0,4.5-4.5v-30a4.5,4.5,0,0,0-4.5-4.5h-30a4.51,4.51,0,0,0-4.5,4.5v30A4.51,4.51,0,0,0,2524.05,764.71Zm.5-5V755h29v4.73Zm29-29V750h-29V730.71Z",
    transform: "translate(-49.36 -8.81)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2570.72,764.71h30a4.51,4.51,0,0,0,4.5-4.5v-30a4.51,4.51,0,0,0-4.5-4.5h-30a4.51,4.51,0,0,0-4.5,4.5v30A4.51,4.51,0,0,0,2570.72,764.71Zm.5-5V755h29v4.73Zm29-29V750h-29V730.71Z",
    transform: "translate(-49.36 -8.81)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2617.38,764.71h30a4.51,4.51,0,0,0,4.5-4.5v-30a4.51,4.51,0,0,0-4.5-4.5h-30a4.51,4.51,0,0,0-4.5,4.5v30A4.51,4.51,0,0,0,2617.38,764.71Zm.5-5V755h29v4.73Zm29-29V750h-29V730.71Z",
    transform: "translate(-49.36 -8.81)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1743.31,880.92h-8.13V854.79h-60.59v216.07h9.22v252.4H1726v-252.4h9.22V931.34a8.71,8.71,0,0,1,6,8.26v99a8,8,0,1,0,16,0V894.82A13.92,13.92,0,0,0,1743.31,880.92Zm0,5a8.91,8.91,0,0,1,8.9,8.9v1.67h-17V885.92Zm-63.72-1v-9H1730v9Zm0-25.13h50.59V871h-50.59ZM1721,1304.26h-32.15V1081H1721Zm-32.15,14v-9H1721v9ZM1721,1076h-32.15v-5.14H1721Zm5-10.14h-46.37V889.92h8.59v160.53a2.5,2.5,0,0,0,5,0V889.92H1730v41h.16v134.94Zm23.24-24.26a3,3,0,0,1-3-3V911.92a2.5,2.5,0,1,0-5,0V929a13.77,13.77,0,0,0-6-2.85v-24.7h17v137.1A3,3,0,0,1,1749.2,1041.6Z",
    transform: "translate(-49.36 -8.81)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2854.57,1001.38h-17.83V980.87a8.51,8.51,0,0,0-8.5-8.5h-150a43.08,43.08,0,0,0-40.91,29.77,43.06,43.06,0,0,0-40.91-29.77H2446.51a8.51,8.51,0,0,0-8.5,8.5v20.51h-17.83a12.51,12.51,0,0,0-12.5,12.5v272.79c0,.1,0,.19,0,.29s0,.09,0,.14v12.58a12.52,12.52,0,0,0,12.5,12.5h434.39a12.52,12.52,0,0,0,12.5-12.5V1287.1s0-.09,0-.14,0-.19,0-.29V1013.88A12.51,12.51,0,0,0,2854.57,1001.38ZM2831.74,1245H2678.06a2.5,2.5,0,0,0,0,5h153.68v10.76a3.5,3.5,0,0,1-3.5,3.5H2640.37a38,38,0,0,1,37.91-35.5l153.46,0ZM2443,1249.87a2.49,2.49,0,0,0,.87.17h154a2.5,2.5,0,0,0,0-5h-154a2.49,2.49,0,0,0-.87.16v-16.43l153.45,0a38,38,0,0,1,37.91,35.5H2446.51a3.5,3.5,0,0,1-3.5-3.5Zm197.27-234.5a38,38,0,0,1,38-38h150a3.5,3.5,0,0,1,3.5,3.5v242.9H2678.28l-2.5,0v.07a43.08,43.08,0,0,0-35.5,22.82ZM2443,980.87a3.5,3.5,0,0,1,3.5-3.5h149.95a38,38,0,0,1,38,38v231.32a43.08,43.08,0,0,0-35.51-22.82v-.1H2443Zm-30.33,33a7.5,7.5,0,0,1,7.5-7.5H2438V1260.8a8.51,8.51,0,0,0,8.5,8.5h381.73a8.51,8.51,0,0,0,8.5-8.5V1006.38h17.83a7.51,7.51,0,0,1,7.5,7.5v272.79a7.52,7.52,0,0,1-7.5,7.5H2420.18a7.51,7.51,0,0,1-7.5-7.5Zm441.89,293.3H2420.18a7.51,7.51,0,0,1-7.5-7.5v-3a12.39,12.39,0,0,0,7.5,2.53h434.39a12.43,12.43,0,0,0,7.5-2.53v3A7.52,7.52,0,0,1,2854.57,1307.18Z",
    transform: "translate(-49.36 -8.81)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2677.06,1185.41h118.15a6.5,6.5,0,0,0,6.5-6.5v-93.83a6.5,6.5,0,0,0-6.5-6.5H2677.06a6.51,6.51,0,0,0-6.5,6.5v93.83A6.51,6.51,0,0,0,2677.06,1185.41Zm-1.5-100.33a1.5,1.5,0,0,1,1.5-1.5h118.15a1.5,1.5,0,0,1,1.5,1.5v93.83a1.5,1.5,0,0,1-1.5,1.5H2677.06a1.5,1.5,0,0,1-1.5-1.5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2673.06,1058.51h126.15a2.5,2.5,0,0,0,0-5H2673.06a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2673.06,1200.62h18.16a2.5,2.5,0,0,0,0-5h-18.16a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2754.25,1195.62h-44.16a2.5,2.5,0,0,0,0,5h44.16a2.5,2.5,0,0,0,0-5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2673.06,1042.49h105.22a2.5,2.5,0,0,0,0-5H2673.06a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2673.06,1026.48h126.15a2.5,2.5,0,0,0,0-5H2673.06a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2673.06,1010.47h76.11a2.5,2.5,0,0,0,0-5h-76.11a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2472.9,1123.56h126.15a2.5,2.5,0,0,0,0-5H2472.9a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2472.9,1107.55h105.22a2.5,2.5,0,0,0,0-5H2472.9a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2472.9,1091.53h126.15a2.5,2.5,0,0,0,0-5H2472.9a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2472.9,1075.52H2549a2.5,2.5,0,0,0,0-5H2472.9a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2601.55,1185.11a2.5,2.5,0,0,0-2.5-2.5H2472.9a2.5,2.5,0,0,0,0,5h126.15A2.5,2.5,0,0,0,2601.55,1185.11Z",
    transform: "translate(-49.36 -8.81)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2472.9,1171.6h105.22a2.5,2.5,0,0,0,0-5H2472.9a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2472.9,1155.58h126.15a2.5,2.5,0,0,0,0-5H2472.9a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2472.9,1139.57h116.15a2.5,2.5,0,0,0,0-5H2472.9a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2476.9,1042.49h122.4a6.51,6.51,0,0,0,6.5-6.5v-17.44a6.51,6.51,0,0,0-6.5-6.5H2476.9a6.51,6.51,0,0,0-6.5,6.5V1036A6.51,6.51,0,0,0,2476.9,1042.49Zm-1.5-23.94a1.5,1.5,0,0,1,1.5-1.5h122.4a1.5,1.5,0,0,1,1.5,1.5V1036a1.5,1.5,0,0,1-1.5,1.5H2476.9a1.5,1.5,0,0,1-1.5-1.5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2336.33,1139.13a4.51,4.51,0,0,0,4.5-4.5v-52a4.51,4.51,0,0,0-4.5-4.5H2090.89a4.51,4.51,0,0,0-4.5,4.5v8.74l-29.74,3.38a6.49,6.49,0,0,0-5.77,6.45v14.85a6.5,6.5,0,0,0,5.77,6.46l29.74,3.37v8.75a4.51,4.51,0,0,0,4.5,4.5Zm-250.14-18.3-29-3.29a1.49,1.49,0,0,1-1.33-1.49V1101.2a1.5,1.5,0,0,1,1.33-1.49l29-3.28Zm53.86-37.7h6v51h-6Zm-5,51h-27v-51h27Zm152.12,0h-6v-51h6Zm5-51h27v51h-27Zm-16,51h-125.1v-51h125.1Zm59.67,0h-11.64v-51h11.64Zm-244.44-51H2103v51h-11.63Z",
    transform: "translate(-49.36 -8.81)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2213.61,1126.13c21.82,0,45-6.13,45-17.5s-23.19-17.5-45-17.5-45,6.13-45,17.5S2191.79,1126.13,2213.61,1126.13Zm0-30c24.79,0,40,7.28,40,12.5s-15.22,12.5-40,12.5-40-7.28-40-12.5S2188.81,1096.13,2213.61,1096.13Z",
    transform: "translate(-49.36 -8.81)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2300.82,997.06H2055.38a4.51,4.51,0,0,0-4.5,4.5v52a4.5,4.5,0,0,0,4.5,4.5h245.44a4.5,4.5,0,0,0,4.5-4.5v-8.74l29.74-3.37a6.5,6.5,0,0,0,5.77-6.46v-14.85a6.5,6.5,0,0,0-5.77-6.46l-29.74-3.37v-8.75A4.51,4.51,0,0,0,2300.82,997.06Zm4.69,18.3,29,3.29a1.51,1.51,0,0,1,1.33,1.49V1035a1.51,1.51,0,0,1-1.33,1.49l-29,3.29Zm-201-13.3h6v51h-6Zm-5,51h-27v-51h27Zm16-51h125.1v51h-125.1Zm130.1,0h6v51h-6Zm11,0h27v51h-27Zm-200.78,0h11.63v51h-11.63Zm244.44,51h-11.64v-51h11.64Z",
    transform: "translate(-49.36 -8.81)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2178.1,1010.06c-21.82,0-45,6.14-45,17.5s23.2,17.5,45,17.5,45-6.13,45-17.5S2199.92,1010.06,2178.1,1010.06Zm0,30c-24.8,0-40-7.28-40-12.5s15.22-12.5,40-12.5,40,7.28,40,12.5S2202.89,1040.06,2178.1,1040.06Z",
    transform: "translate(-49.36 -8.81)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3012.51,1135.55V939.11a8.51,8.51,0,0,0-8.5-8.5h-79.44a8.51,8.51,0,0,0-8.5,8.5v196.44a8.51,8.51,0,0,0,8.5,8.5H3004A8.51,8.51,0,0,0,3012.51,1135.55Zm-91.44,0V939.11a3.5,3.5,0,0,1,3.5-3.5h6.18v203.44h-6.18A3.5,3.5,0,0,1,2921.07,1135.55Zm86.44,0a3.5,3.5,0,0,1-3.5,3.5h-68.26V935.61H3004a3.5,3.5,0,0,1,3.5,3.5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2744.41,885.08h190.83a32.54,32.54,0,0,0,32.5-32.5V603a32.54,32.54,0,0,0-32.5-32.5H2744.41a10.51,10.51,0,0,0-10.5,10.5V874.58A10.51,10.51,0,0,0,2744.41,885.08ZM2765,575.67h8.5V879.86H2765ZM2962.74,603V852.58a27.53,27.53,0,0,1-27.5,27.5H2778.49V575.45h156.75A27.53,27.53,0,0,1,2962.74,603Zm-223.83-22a5.5,5.5,0,0,1,5.5-5.5H2760V880.08h-15.58a5.5,5.5,0,0,1-5.5-5.5Z",
    transform: "translate(-49.36 -8.81)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2237.05,1182.5a117.45,117.45,0,0,0-117.32,117.32v2.5h234.64v-2.5A117.45,117.45,0,0,0,2237.05,1182.5Zm-112.3,114.82a112.47,112.47,0,0,1,109.8-109.79v31.18a81.24,81.24,0,0,0-78.61,78.61Zm109.8-73.61v73.61h-73.64A76.26,76.26,0,0,1,2234.55,1223.71Zm5,73.61v-73.61a76.26,76.26,0,0,1,73.63,73.61Zm78.61,0a81.26,81.26,0,0,0-78.61-78.61v-31.18a112.46,112.46,0,0,1,109.79,109.79Z",
    transform: "translate(-49.36 -8.81)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3188.21,755.63a16.24,16.24,0,0,0,0-22.93h0a16.21,16.21,0,1,0,0,22.93Zm-3.53-3.54a11.2,11.2,0,0,1-13.88,1.56l15.44-15.44A11.23,11.23,0,0,1,3184.68,752.09Zm-15.85-15.85a11.2,11.2,0,0,1,13.88-1.56l-15.45,15.44a11.18,11.18,0,0,1,1.57-13.88Z",
    transform: "translate(-49.36 -8.81)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3224.37,1005.22a14.26,14.26,0,0,0-11.73-14V975.38h-14.89v-168a6.51,6.51,0,0,0-6.5-6.5h-2.68V778.06a35.91,35.91,0,0,0,4.84-65.69V667.23h-7V643.84a9.64,9.64,0,1,0-19.28,0v23.39h-7v45.14a35.91,35.91,0,0,0,4.47,65.56v23h-2.31a6.51,6.51,0,0,0-6.5,6.5v205.64a6.5,6.5,0,0,0,1,3.4l10.35,16.93a6.45,6.45,0,0,0,5.51,3.12,6.57,6.57,0,0,0,1.8-.25h0v63.81a6.46,6.46,0,0,0,4.74,6.26,7,7,0,0,0,1.8.25,6.43,6.43,0,0,0,5.51-3.12l10.35-16.94a6.44,6.44,0,0,0,1-3.39v-48.08h14.89v-15.84A14.25,14.25,0,0,0,3224.37,1005.22Zm-16.73,8.87a9.22,9.22,0,0,1,0-17.75Zm-14.89-206.66v168h-13.36v-168a1.5,1.5,0,0,1,1.5-1.5h10.36A1.5,1.5,0,0,1,3192.75,807.43Zm-20.64-163.59a4.64,4.64,0,1,1,9.28,0v23.39h-9.28Zm-7,28.39h23.32v38a36.19,36.19,0,0,0-23.32,0Zm-19.23,71.93a30.88,30.88,0,1,1,9,21.85A30.71,30.71,0,0,1,3145.86,744.16ZM3174.11,1030a1.5,1.5,0,0,1-2.78.79L3161,1013.86a1.57,1.57,0,0,1-.22-.79V807.43a1.5,1.5,0,0,1,1.5-1.5h10.36a1.5,1.5,0,0,1,1.5,1.5Zm-1.5-229.08h-3.05v-21.6a36.18,36.18,0,0,0,14,.07v21.53h-2.68a6.46,6.46,0,0,1-8.28,0Zm20.14,282.2a1.5,1.5,0,0,1-.22.78l-10.36,16.94a1.4,1.4,0,0,1-1.68.66,1.43,1.43,0,0,1-1.1-1.44v-65h13.36Zm-13.36-53.08V980.38h28.25v10.84a14.21,14.21,0,0,0,0,28v10.84Zm33.25-16V996.34a9.22,9.22,0,0,1,0,17.75Z",
    transform: "translate(-49.36 -8.81)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgGraphic);
export default __webpack_public_path__ + "static/media/bgGraphic.97db7603d57aec14a2956b2828beaca6.svg";
export { ForwardRef as ReactComponent };